webpackJsonptesseract([2],{

/***/ 308:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DccWidget", function() { return DccWidget; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact_i18n__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dcc__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__intl_json__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__intl_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__intl_json__);




var DccWidget = Object(__WEBPACK_IMPORTED_MODULE_0_preact_i18n__["e" /* default */])(__WEBPACK_IMPORTED_MODULE_1__components_dcc__["a" /* default */], { scope: 'dccv2', definition: __WEBPACK_IMPORTED_MODULE_2__intl_json___default.a });
/* harmony default export */ __webpack_exports__["default"] = (DccWidget);

/***/ }),

/***/ 360:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = void 0;

var _react = _interopRequireDefault(__webpack_require__(75));

var _reactDom = _interopRequireDefault(__webpack_require__(75));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);

  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }

  return onDemandSlides;
}; // return list of slides that need to be present


exports.getOnDemandLazySlides = getOnDemandLazySlides;

var getRequiredLazySlides = function getRequiredLazySlides(spec) {
  var requiredSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);

  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    requiredSlides.push(slideIndex);
  }

  return requiredSlides;
}; // startIndex that needs to be present


exports.getRequiredLazySlides = getRequiredLazySlides;

var lazyStartIndex = function lazyStartIndex(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};

exports.lazyStartIndex = lazyStartIndex;

var lazyEndIndex = function lazyEndIndex(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};

exports.lazyEndIndex = lazyEndIndex;

var lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};

exports.lazySlidesOnLeft = lazySlidesOnLeft;

var lazySlidesOnRight = function lazySlidesOnRight(spec) {
  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
}; // get width of an element


exports.lazySlidesOnRight = lazySlidesOnRight;

var getWidth = function getWidth(elem) {
  return elem && elem.offsetWidth || 0;
};

exports.getWidth = getWidth;

var getHeight = function getHeight(elem) {
  return elem && elem.offsetHeight || 0;
};

exports.getHeight = getHeight;

var getSwipeDirection = function getSwipeDirection(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var xDist, yDist, r, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r * 180 / Math.PI);

  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }

  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return "left";
  }

  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return "right";
  }

  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return "up";
    } else {
      return "down";
    }
  }

  return "vertical";
}; // whether or not we can go next


exports.getSwipeDirection = getSwipeDirection;

var canGoNext = function canGoNext(spec) {
  var canGo = true;

  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
      canGo = false;
    }
  }

  return canGo;
}; // given an object and a list of keys, return new object with given keys


exports.canGoNext = canGoNext;

var extractObject = function extractObject(spec, keys) {
  var newObject = {};
  keys.forEach(function (key) {
    return newObject[key] = spec[key];
  });
  return newObject;
}; // get initialized state


exports.extractObject = extractObject;

var initializedState = function initializedState(spec) {
  // spec also contains listRef, trackRef
  var slideCount = _react.default.Children.count(spec.children);

  var listWidth = Math.ceil(getWidth(_reactDom.default.findDOMNode(spec.listRef)));
  var trackWidth = Math.ceil(getWidth(_reactDom.default.findDOMNode(spec.trackRef)));
  var slideWidth;

  if (!spec.vertical) {
    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;

    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
      centerPaddingAdj *= listWidth / 100;
    }

    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }

  var slideHeight = _reactDom.default.findDOMNode(spec.listRef) && getHeight(_reactDom.default.findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;

  if (spec.rtl && spec.currentSlide === undefined) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }

  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides({
    currentSlide: currentSlide,
    lazyLoadedList: lazyLoadedList
  }, spec);
  lazyLoadedList.concat(slidesToLoad);
  var state = {
    slideCount: slideCount,
    slideWidth: slideWidth,
    listWidth: listWidth,
    trackWidth: trackWidth,
    currentSlide: currentSlide,
    slideHeight: slideHeight,
    listHeight: listHeight,
    lazyLoadedList: lazyLoadedList
  };

  if (spec.autoplaying === null && spec.autoplay) {
    state["autoplaying"] = "playing";
  }

  return state;
};

exports.initializedState = initializedState;

var slideHandler = function slideHandler(spec) {
  var waitForAnimate = spec.waitForAnimate,
      animating = spec.animating,
      fade = spec.fade,
      infinite = spec.infinite,
      index = spec.index,
      slideCount = spec.slideCount,
      lazyLoadedList = spec.lazyLoadedList,
      lazyLoad = spec.lazyLoad,
      currentSlide = spec.currentSlide,
      centerMode = spec.centerMode,
      slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      useCSS = spec.useCSS;
  if (waitForAnimate && animating) return {};
  var animationSlide = index,
      finalSlide,
      animationLeft,
      finalLeft;
  var state = {},
      nextState = {};

  if (fade) {
    if (!infinite && (index < 0 || index >= slideCount)) return {};

    if (index < 0) {
      animationSlide = index + slideCount;
    } else if (index >= slideCount) {
      animationSlide = index - slideCount;
    }

    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList.push(animationSlide);
    }

    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList: lazyLoadedList
    };
    nextState = {
      animating: false
    };
  } else {
    finalSlide = animationSlide;

    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
    }

    animationLeft = getTrackLeft(_objectSpread({}, spec, {
      slideIndex: animationSlide
    }));
    finalLeft = getTrackLeft(_objectSpread({}, spec, {
      slideIndex: finalSlide
    }));

    if (!infinite) {
      if (animationLeft === finalLeft) animationSlide = finalSlide;
      animationLeft = finalLeft;
    }

    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_objectSpread({}, spec, {
      currentSlide: animationSlide
    })));

    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread({}, spec, {
          left: finalLeft
        })),
        lazyLoadedList: lazyLoadedList
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS(_objectSpread({}, spec, {
          left: animationLeft
        })),
        lazyLoadedList: lazyLoadedList
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread({}, spec, {
          left: finalLeft
        })),
        swipeLeft: null
      };
    }
  }

  return {
    state: state,
    nextState: nextState
  };
};

exports.slideHandler = slideHandler;

var changeSlide = function changeSlide(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      slideCount = spec.slideCount,
      currentSlide = spec.currentSlide,
      lazyLoad = spec.lazyLoad,
      infinite = spec.infinite;
  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

  if (options.message === "previous") {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;

    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }
  } else if (options.message === "next") {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;

    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }
  } else if (options.message === "dots") {
    // Click on dots
    targetSlide = options.index * options.slidesToScroll;

    if (targetSlide === options.currentSlide) {
      return null;
    }
  } else if (options.message === "children") {
    // Click on the slides
    targetSlide = options.index;

    if (targetSlide === options.currentSlide) {
      return null;
    }

    if (infinite) {
      var direction = siblingDirection(_objectSpread({}, spec, {
        targetSlide: targetSlide
      }));

      if (targetSlide > options.currentSlide && direction === "left") {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === "right") {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === "index") {
    targetSlide = Number(options.index);

    if (targetSlide === options.currentSlide) {
      return null;
    }
  }

  return targetSlide;
};

exports.changeSlide = changeSlide;

var keyHandler = function keyHandler(e, accessibility, rtl) {
  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
  if (e.keyCode === 37) return rtl ? "next" : "previous";
  if (e.keyCode === 39) return rtl ? "previous" : "next";
  return "";
};

exports.keyHandler = keyHandler;

var swipeStart = function swipeStart(e, swipe, draggable) {
  e.target.tagName === "IMG" && e.preventDefault();
  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
  return {
    dragging: true,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};

exports.swipeStart = swipeStart;

var swipeMove = function swipeMove(e, spec) {
  // spec also contains, trackRef and slideIndex
  var scrolling = spec.scrolling,
      animating = spec.animating,
      vertical = spec.vertical,
      swipeToSlide = spec.swipeToSlide,
      verticalSwiping = spec.verticalSwiping,
      rtl = spec.rtl,
      currentSlide = spec.currentSlide,
      edgeFriction = spec.edgeFriction,
      edgeDragged = spec.edgeDragged,
      onEdge = spec.onEdge,
      swiped = spec.swiped,
      swiping = spec.swiping,
      slideCount = spec.slideCount,
      slidesToScroll = spec.slidesToScroll,
      infinite = spec.infinite,
      touchObject = spec.touchObject,
      swipeEvent = spec.swipeEvent,
      listHeight = spec.listHeight,
      listWidth = spec.listWidth;
  if (scrolling) return;
  if (animating) return e.preventDefault();
  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
  var swipeLeft,
      state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));

  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return {
      scrolling: true
    };
  }

  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;

  if (!infinite) {
    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;

      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state["edgeDragged"] = true;
      }
    }
  }

  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state["swiped"] = true;
  }

  if (!vertical) {
    if (!rtl) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }

  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }

  state = _objectSpread({}, state, {
    touchObject: touchObject,
    swipeLeft: swipeLeft,
    trackStyle: getTrackCSS(_objectSpread({}, spec, {
      left: swipeLeft
    }))
  });

  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }

  if (touchObject.swipeLength > 10) {
    state["swiping"] = true;
    e.preventDefault();
  }

  return state;
};

exports.swipeMove = swipeMove;

var swipeEnd = function swipeEnd(e, spec) {
  var dragging = spec.dragging,
      swipe = spec.swipe,
      touchObject = spec.touchObject,
      listWidth = spec.listWidth,
      touchThreshold = spec.touchThreshold,
      verticalSwiping = spec.verticalSwiping,
      listHeight = spec.listHeight,
      currentSlide = spec.currentSlide,
      swipeToSlide = spec.swipeToSlide,
      scrolling = spec.scrolling,
      onSwipe = spec.onSwipe;

  if (!dragging) {
    if (swipe) e.preventDefault();
    return {};
  }

  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping); // reset the state of touch related state variables.

  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };

  if (scrolling) {
    return state;
  }

  if (!touchObject.swipeLength) {
    return state;
  }

  if (touchObject.swipeLength > minSwipe) {
    e.preventDefault();

    if (onSwipe) {
      onSwipe(swipeDirection);
    }

    var slideCount, newSlide;

    switch (swipeDirection) {
      case "left":
      case "up":
        newSlide = currentSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 0;
        break;

      case "right":
      case "down":
        newSlide = currentSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 1;
        break;

      default:
        slideCount = currentSlide;
    }

    state["triggerSlideHandler"] = slideCount;
  } else {
    // Adjust the track back to it's original position.
    var currentLeft = getTrackLeft(spec);
    state["trackStyle"] = getTrackAnimateCSS(_objectSpread({}, spec, {
      left: currentLeft
    }));
  }

  return state;
};

exports.swipeEnd = swipeEnd;

var getNavigableIndexes = function getNavigableIndexes(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];

  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }

  return indexes;
};

exports.getNavigableIndexes = getNavigableIndexes;

var checkNavigable = function checkNavigable(spec, index) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;

  if (index > navigables[navigables.length - 1]) {
    index = navigables[navigables.length - 1];
  } else {
    for (var n in navigables) {
      if (index < navigables[n]) {
        index = prevNavigable;
        break;
      }

      prevNavigable = navigables[n];
    }
  }

  return index;
};

exports.checkNavigable = checkNavigable;

var getSlideCount = function getSlideCount(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;

  if (spec.swipeToSlide) {
    var swipedSlide;

    var slickList = _reactDom.default.findDOMNode(spec.listRef);

    var slides = slickList.querySelectorAll(".slick-slide");
    Array.from(slides).every(function (slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }

      return true;
    });

    if (!swipedSlide) {
      return 0;
    }

    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
};

exports.getSlideCount = getSlideCount;

var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error("Keys Missing:", spec);
};

exports.checkSpecKeys = checkSpecKeys;

var getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var trackWidth, trackHeight;
  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;

  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }

  var style = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };

  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
    style = _objectSpread({}, style, {
      WebkitTransform: WebkitTransform,
      transform: transform,
      msTransform: msTransform
    });
  } else {
    if (spec.vertical) {
      style["top"] = spec.left;
    } else {
      style["left"] = spec.left;
    }
  }

  if (spec.fade) style = {
    opacity: 1
  };
  if (trackWidth) style.width = trackWidth;
  if (trackHeight) style.height = trackHeight; // Fallback for IE8

  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + "px";
    } else {
      style.marginTop = spec.left + "px";
    }
  }

  return style;
};

exports.getTrackCSS = getTrackCSS;

var getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var style = getTrackCSS(spec); // useCSS is true by default so it can be undefined

  if (spec.useTransform) {
    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
  } else {
    if (spec.vertical) {
      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    } else {
      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    }
  }

  return style;
};

exports.getTrackAnimateCSS = getTrackAnimateCSS;

var getTrackLeft = function getTrackLeft(spec) {
  if (spec.unslick) {
    return 0;
  }

  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
  var slideIndex = spec.slideIndex,
      trackRef = spec.trackRef,
      infinite = spec.infinite,
      centerMode = spec.centerMode,
      slideCount = spec.slideCount,
      slidesToShow = spec.slidesToShow,
      slidesToScroll = spec.slidesToScroll,
      slideWidth = spec.slideWidth,
      listWidth = spec.listWidth,
      variableWidth = spec.variableWidth,
      slideHeight = spec.slideHeight,
      fade = spec.fade,
      vertical = spec.vertical;
  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;

  if (fade || spec.slideCount === 1) {
    return 0;
  }

  var slidesToOffset = 0;

  if (infinite) {
    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children

    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    } // shift current slide to center of the frame


    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }

    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }

  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;

  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }

  if (variableWidth === true) {
    var targetSlideIndex;

    var trackElem = _reactDom.default.findDOMNode(trackRef);

    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;

    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;

      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }

      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }

  return targetLeft;
};

exports.getTrackLeft = getTrackLeft;

var getPreClones = function getPreClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  if (spec.variableWidth) {
    return spec.slideCount;
  }

  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};

exports.getPreClones = getPreClones;

var getPostClones = function getPostClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  return spec.slideCount;
};

exports.getPostClones = getPostClones;

var getTotalSlides = function getTotalSlides(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};

exports.getTotalSlides = getTotalSlides;

var siblingDirection = function siblingDirection(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return "left";
    }

    return "right";
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return "right";
    }

    return "left";
  }
};

exports.siblingDirection = siblingDirection;

var slidesOnRight = function slidesOnRight(_ref) {
  var slidesToShow = _ref.slidesToShow,
      centerMode = _ref.centerMode,
      rtl = _ref.rtl,
      centerPadding = _ref.centerPadding;

  // returns no of slides on the right of active slide
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) right += 1;
    if (rtl && slidesToShow % 2 === 0) right += 1;
    return right;
  }

  if (rtl) {
    return 0;
  }

  return slidesToShow - 1;
};

exports.slidesOnRight = slidesOnRight;

var slidesOnLeft = function slidesOnLeft(_ref2) {
  var slidesToShow = _ref2.slidesToShow,
      centerMode = _ref2.centerMode,
      rtl = _ref2.rtl,
      centerPadding = _ref2.centerPadding;

  // returns no of slides on the left of active slide
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) left += 1;
    if (!rtl && slidesToShow % 2 === 0) left += 1;
    return left;
  }

  if (rtl) {
    return slidesToShow - 1;
  }

  return 0;
};

exports.slidesOnLeft = slidesOnLeft;

var canUseDOM = function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};

exports.canUseDOM = canUseDOM;

/***/ }),

/***/ 369:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export addRestriction */
/* unused harmony export removeRestriction */
/* harmony export (immutable) */ __webpack_exports__["b"] = isAllowed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util___ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_restriction___ = __webpack_require__(407);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__components_restriction___["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__adapters_sethomepage__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__adapters_device__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__adapters_delay__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__adapters_debug__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__adapters_gen4__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__adapters_authn__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__adapters_notauthn__ = __webpack_require__(417);


//Globally available Adapters. addRestriction populates this.
var restrictions = {
	default: function _default() {
		return false;
	}
};

/**
 * Add a new restriction to the global restriction system.
 * @param {String} restriction a name or regex for the restirction you want to add.
 * @param {Function} impl An adapter function: (restriction, props, context) => {}.
 */
function addRestriction(restriction, adapter) {
	if (!restriction || !adapter) return false;
	restrictions[restriction] = adapter;
	return true;
}

/**
 * Forcefully removes a restriction from the global restriction system.
 * @param {String} restriction a name or regex of the restirction you want to remove.
 */
function removeRestriction(restriction) {
	if (!restriction || !restrictions[restriction]) return false;
	delete restrictions[restriction];
	return true;
}

/**
 * Resolve a restriction adapter by restriction name.
 * @param {String} restriction The name of the restriction. Either an explicit name or a string that matches a regex.
 * @param [Object] props The props object that this restriction is being resolved for.
 * @param [Object] context The context object that this restriction is being resolved for.
 * @returns A boolean or a Promise that resolves to a boolean.
 */
function isAllowed() {
	var restriction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
	var props = arguments[1];
	var context = arguments[2];

	// AND - []:
	if (Array.isArray(restriction)) {
		return Object(__WEBPACK_IMPORTED_MODULE_0__util___["a" /* serialAND */])(restriction, function (r) {
			return isAllowed(r, props, context);
		});
	}

	// OR - {or:[]}
	if (restriction.or) {
		return Object(__WEBPACK_IMPORTED_MODULE_0__util___["b" /* serialOR */])(restriction.or, function (r) {
			return isAllowed(r, props, context);
		});
	}

	// Individual Restriction
	var matches = Object.keys(restrictions).filter(function (key) {
		return restriction.match(key);
	});
	var restrictionMatch = matches.length > 0 && restrictions[matches[0]] || restrictions.default;
	return restrictionMatch(restriction, props, context);
}

/**
 * This Component can be used to optioanlly render children based on the result of
 * a supplied restriction condition.
 */



/*
Add built-in Restriction Adapters:
*/


addRestriction(__WEBPACK_IMPORTED_MODULE_2__adapters_sethomepage__["a" /* NAME */], __WEBPACK_IMPORTED_MODULE_2__adapters_sethomepage__["b" /* default */]);


addRestriction(__WEBPACK_IMPORTED_MODULE_3__adapters_device__["a" /* NAME */], __WEBPACK_IMPORTED_MODULE_3__adapters_device__["b" /* default */]);


addRestriction(__WEBPACK_IMPORTED_MODULE_4__adapters_delay__["a" /* NAME */], __WEBPACK_IMPORTED_MODULE_4__adapters_delay__["b" /* default */]);


addRestriction(__WEBPACK_IMPORTED_MODULE_5__adapters_debug__["a" /* NAME */], __WEBPACK_IMPORTED_MODULE_5__adapters_debug__["b" /* default */]);


addRestriction(__WEBPACK_IMPORTED_MODULE_6__adapters_gen4__["a" /* NAME */], __WEBPACK_IMPORTED_MODULE_6__adapters_gen4__["b" /* default */]);


addRestriction(__WEBPACK_IMPORTED_MODULE_7__adapters_authn__["a" /* NAME */], __WEBPACK_IMPORTED_MODULE_7__adapters_authn__["b" /* default */]);


addRestriction(__WEBPACK_IMPORTED_MODULE_8__adapters_notauthn__["a" /* NAME */], __WEBPACK_IMPORTED_MODULE_8__adapters_notauthn__["b" /* default */]);

/***/ }),

/***/ 374:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wire;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dlv__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dlv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_dlv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(375);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



 // eslint-disable-line no-unused-vars

/**	Creates a higher order component (HOC) that resolves (async) values from a model to props.
 *	This allows (but importantly abstracts) context access, and manages re-rendering in response to resolved data.
 *	`wire()` is simply a formalization of what is typically done as side-effects within `componentDidMount()`.
 *
 *	@name wire
 *	@param {String} [contextNamespace]		The context property at which to obtain a model instance. If empty, all of `context` is used.
 *	@param {Object|Function} [mapToProps]	Maps incoming props to model method call descriptors: `['method.name', ...args]`
 *	@param {Function} [mapModelToProps]		Maps model properties/methods to props: `model => ({ prop: model.property })`
 *	@returns {Function} wiring(Child) -> WireDataWrapper<Child>.  The resulting HOC has a method `getWrappedComponent()` that returns the Child that was wrapped
 *
 *	@example
 *	// resolves news.getTopStories(), passing it down as a "stories" prop
 *	let withTopStories = wire('news', {
 *		stories: 'getTopStories'
 *	});
 *	export default withTopStories( props =>
 *		<ul>
 *			{ props.stories.map( item =>
 *				<li>{item.title}</li>
 *			) }
 *		</ul>
 *	);
 *
 *	@example
 *	// resolves a news story by ID and passes it down as a "story" prop
 *	let withStory = wire('news', props => ({
 *		story: ['getStory', props.id]
 *	}));
 *
 *	// Simple "view" functional component to render a story
 *	const StoryView = ({ story }) => (
 *		<div class="story">
 *			<h2>{story ? story.title : '...'}</h2>
 *			<p>{story && story.content}</p>
 *		</div>
 *	);
 *
 *	// Wrap StoryView in the loader component created by wire()
 *	const Story = withStory(StoryView);
 *
 *	//Get access to the wrapped Component
 *	Story.getWrappedComponent() === StoryView; // true
 *
 *	// Provide a news model into context so Story can wire up to it
 *	render(
 *		<Provider news={newsModel({ origin: '//news.api' })}>
 *			<div class="demo">
 *				<h1>News Story #1234:</h1>
 *				<Story id="1234" />
 *			</div>
 *		</Provider>
 *	);
 */
function wire(contextNamespace) {
	var mapToProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	var mapModelToProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_2__util__["c" /* noop */];

	var CACHE = {};

	return function (Child) {
		var WireDataWrapper = function (_Component) {
			_inherits(WireDataWrapper, _Component);

			WireDataWrapper.prototype.invoke = function invoke(props, keysOnly, refresh) {
				var _this2 = this;

				var source = Object(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* get */])(this.context, contextNamespace),
				    isFunction = typeof mapToProps === 'function',
				    mapping = isFunction ? mapToProps(props) : mapToProps,
				    keys = [];

				var _loop = function _loop(prop) {
					if (Object.prototype.hasOwnProperty.call(mapping, prop)) {
						var path = mapping[prop],
						    args = [];
						if (Array.isArray(path)) {
							args = path.slice(1);
							path = path[0];
						}
						if (!isFunction) {
							args = args.map(function (p) {
								return typeof p === 'string' && p in props ? props[p] : p;
							});
						}

						var key = JSON.stringify([contextNamespace, path].concat(args));
						keys.push(key);
						if (keysOnly) return 'continue';

						if (!refresh && _this2.currentKeys[prop] === key) {
							return 'continue';
						}

						_this2.currentKeys[prop] = key;

						var p = void 0;
						if (typeof path === 'function') {
							p = path();
						} else if (typeof path !== 'string') {
							p = path;
						} else {
							var fn = __WEBPACK_IMPORTED_MODULE_1_dlv___default()(source, path);
							if (!fn) throw Error(contextNamespace + '.' + path + ' not found.');
							p = fn.apply(undefined, args);
						}

						if (p && p.then !== undefined && p.__wiretieResolved) {
							p = p.__wiretieResolved;
						}

						// magically re-render for async values:
						if (p && p.then !== undefined) {

							var newState = {};
							var _state = _this2.state,
							    pending = _state.pending,
							    rejected = _state.rejected;

							// set that this property call is pending if not already set

							if (!pending) {
								var _newState$pending;

								newState.pending = (_newState$pending = {}, _newState$pending[prop] = true, _newState$pending);
							} else if (!pending[prop]) {
								var _extends2;

								newState.pending = _extends({}, pending, (_extends2 = {}, _extends2[prop] = true, _extends2));
							}

							// Since we're starting a new call for prop, remove any old rejected status for it if it exists
							if (rejected && rejected[prop]) {
								newState.rejected = Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* removeKeyFromObject */])(prop, rejected);
							}

							var id = ++_this2.counter;
							_this2.tracking[prop] = id;

							// handle the promise results
							p.then(function (data) {
								p.__wiretieResolved = data;

								// cache the result if the promise resolved successfully
								var newState = {};
								newState[prop] = CACHE[key] = data;
								return newState;
							}).catch(function (err) {
								if (_this2.tracking[prop] !== id) return;

								// If there was an error, use the cached value if available and set the rejected property
								var rejected = _this2.state.rejected && _extends({}, _this2.state.rejected) || {};
								rejected[prop] = err;
								var newState = { rejected: rejected };
								if (CACHE[key]) newState[prop] = CACHE[key];

								//Anonymous rejection to log to the console
								Promise.reject(err);

								return newState;
							}).then(function (newState) {
								if (_this2.tracking[prop] !== id) return;
								delete _this2.tracking[prop];

								// remove the pending key for this prop if necessary
								var pending = _this2.state.pending;
								if (pending && pending[prop]) newState.pending = Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* removeKeyFromObject */])(prop, pending);
								_this2.setState(newState);
							});

							// if we got a Promise but there's a cached value, use that until the new value comes in:
							if (typeof CACHE[key] !== 'undefined') {
								newState[prop] = CACHE[key];
							}
							_this2.setState(newState);
						} else {
							var _this2$setState;

							//for non-promises, just set the state with the value
							_this2.setState((_this2$setState = {}, _this2$setState[prop] = p, _this2$setState));
						}
					}
				};

				for (var prop in mapping) {
					var _ret = _loop(prop);

					if (_ret === 'continue') continue;
				}return this.keys = keys;
			};

			function WireDataWrapper(props, context) {
				_classCallCheck(this, WireDataWrapper);

				var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

				_this.state = {};
				_this.currentKeys = {};

				// used for creating unique IDs.
				_this.tracking = {};
				_this.counter = 0;

				_this.mapping = mapModelToProps(Object(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* get */])(context, contextNamespace), props);

				/** Props passed to your wrapped component.
     *	@name props
     */

				/** If any Promises are pending, the corresponding prop names will be keys in a `props.pending` Object.
    		 *	If there are no pending promises, `props.pending` is `undefined`.
     *	@name pending
     *	@memberof props
     *	@type {Object<Boolean>|undefined}
     */

				/** If any Promises have been rejected, their values are available in a `props.rejected` Object.
    	 *	If there are no rejected promises, `props.rejected` is `undefined`.
    	 *	@name rejected
     *	@memberof props
    	 *	@type {Object<Error>|undefined}
    	 */

				/** A `refresh()` method is passed down as a prop.
     *	Invoking this method re-fetches all data props, bypassing the cache.
     *	@name refresh
     *	@memberof props
     *	@function
     */
				_this.refresh = function () {
					_this.invoke(_this.props, false, true);
				};
				return _this;
			}

			WireDataWrapper.prototype.componentWillMount = function componentWillMount() {
				this.invoke(this.props);
			};

			WireDataWrapper.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
				if (!Object(__WEBPACK_IMPORTED_MODULE_2__util__["e" /* shallowEqual */])(nextProps, this.props) && Object(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* join */])(this.keys) !== Object(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* join */])(this.invoke(nextProps, true))) {
					this.invoke(nextProps);
				}
			};

			WireDataWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(props, state) {
				return !Object(__WEBPACK_IMPORTED_MODULE_2__util__["e" /* shallowEqual */])(props, this.props) || !Object(__WEBPACK_IMPORTED_MODULE_2__util__["e" /* shallowEqual */])(state, this.state);
			};

			WireDataWrapper.prototype.render = function render(props, state) {
				return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Child, _extends({ refresh: this.refresh }, this.mapping, props, state));
			};

			return WireDataWrapper;
		}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

		WireDataWrapper.getWrappedComponent = Child && Child.getWrappedComponent || function () {
			return Child;
		};
		return WireDataWrapper;
	};
}

/***/ }),

/***/ 375:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = join;
/* harmony export (immutable) */ __webpack_exports__["a"] = get;
/* harmony export (immutable) */ __webpack_exports__["e"] = shallowEqual;
/* harmony export (immutable) */ __webpack_exports__["d"] = removeKeyFromObject;
/* harmony export (immutable) */ __webpack_exports__["c"] = noop;
/* unused harmony export assign */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/** Joins an array (using newlines) if it exists, otherwise returns an empty string
 *	@private
 */
function join(arr) {
	return arr ? arr.join('\n') : '';
}

/** Returns an object property if `key` is non-empty, otherwise returns the object itself
 *	@private
 */
function get(obj, key) {
	return key ? obj[key] : obj;
}

/** Check if two objects have the same keys, and that all values are strictly equal.
 *	@private
 */
function shallowEqual(a, b) {
	for (var key in a) {
		if (a[key] !== b[key]) return false;
	}for (var _key in b) {
		if (!(_key in a)) return false;
	}return true;
}

/** Returns a clone of the given object without a certain key.
 *	Returns undefined if resulting object would be empty.
 *	@private
 */
function removeKeyFromObject(key, obj) {
	if (Object.prototype.hasOwnProperty.call(obj, key)) {
		obj = _extends({}, obj);
		delete obj[key];
	}
	return Object.keys(obj).length ? obj : undefined;
}

/** An empty function.
 *	@private
 */
function noop() {}

/** Object.assign ponyfill (note: used by Rollup)
 *	@private
 */
function assign(obj) {
	for (var i = 1; i < arguments.length; i++) {
		// eslint-disable-next-line guard-for-in, prefer-rest-params
		for (var p in arguments[i]) {
			obj[p] = arguments[i][p];
		}
	}
	return obj;
}

/***/ }),

/***/ 393:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__intentToUrl__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__intentObjToUrl__ = __webpack_require__(405);
/* unused harmony reexport default */
/* unused harmony reexport intentToUrl */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__intentObjToUrl__["a"]; });




/***/ }),

/***/ 403:
/***/ (function(module, exports) {

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction(target) {
    return typeof target === 'function';
}

module.exports = {
    isFunction : isFunction,
    isArray : isArray,
    each : each
};


/***/ }),

/***/ 404:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * intentToUrl is a method that takes in an intent and converts to a url
 * intents are... special. Vestigial expression of URLs from days of old.
 * @param {String} intent
 * @param {String} origin, optional. Will prefix with origin.
 * @return {String} url, defaults to # and returns http/https as is.
 */
function intentToUrl(intent, origin) {
	// examples: synacornewsread://category=News&article=the_associated_press-coaches_qbs_lapped_by_bradybelichick_marvel_at_suc-ap
	// 					 primetime://vendor=WKBW - Buffalo, NY&player=ndn&canonical=wkbw_buffalo_ny-forever_young-ndn",
	// handle a falsey input
	if (!intent) {
		return;
	}
	origin = origin || '';
	if (intent.indexOf('//') === -1) {
		return origin + intent;
	}
	// handle a schemeless URL
	if (intent.indexOf('//') === 0) {
		return window.location.protocol + intent;
	}
	if (intent.match(/https?/)) {
		return intent;
	}

	// We have something that is an intent
	var path = false;

	var _intent$split = intent.split(/:\/\//),
	    intentType = _intent$split[0],
	    dataString = _intent$split[1];

	var data = [];

	dataString.split(/&/).forEach(function (item) {
		var _mapItem = mapItem(item),
		    key = _mapItem[0],
		    val = _mapItem[1];

		data.push(encodeURIComponent(key) + '/' + encodeURIComponent(val));
	});

	if (intentType.match(/synacornewsread|primetime/)) {
		path = '/news/read/' + data.join('/');
	}

	return path === false ? false : origin + path;
}

/**
 * Maps an intent URL parameter to its translated key/value
 * @param  {String} item a URL query param i.e.: key=value
 * @return {Array}      [key, value]
 */
var mapItem = function mapItem(item) {
	return item.split(/=/).map(function (part) {
		return INTENT_PARAMS_MAP[part] || part;
	});
};

var INTENT_PARAMS_MAP = {
	canonical: 'article'
};

/***/ }),

/***/ 405:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = intentObjToUrl;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var entries = function entries(obj) {
	var ownProps = Object.keys(obj),
	    i = ownProps.length,
	    resArray = new Array(i);
	while (i--) {
		resArray[i] = [ownProps[i], obj[ownProps[i]]];
	}return resArray;
};

/**
 * intentObjToUrl is a method that takes in an intent object and converts to a url
 * this is an evolution of an intent string that is less terrible
 * @param {String} intentObj
 * @param {String} origin, optional. Will prefix with origin.
 * @return {String} url, returns false if it cannot be processed.
 */
function intentObjToUrl(intentObj, origin) {
	var map = void 0,
	    path = void 0;
	if (!intentObj || (typeof intentObj === 'undefined' ? 'undefined' : _typeof(intentObj)) !== 'object') {
		return false;
	}

	origin = origin || '';

	if (intentObj.href) {
		return intentObj.href;
	}

	if (typeof INTENT_PARAMS_MAP[intentObj.type] === 'undefined') {
		return false;
	}

	map = INTENT_PARAMS_MAP[intentObj.type];

	path = map._path;

	// iterate over intentObj
	entries(intentObj.meta).map(function (k) {
		var key = k[0];
		if (map[key]) {
			key = map[key];
		}
		path += '/' + key + '/' + k[1];
	});
	return origin + path;
}

var INTENT_PARAMS_MAP = {
	video: {
		_path: '/player',
		canonical: 'article',
		asset: 'article'
	},
	article: {
		_path: '/news/read'
	},
	slideshow: {
		_path: '/slideshow',
		asset: 'article'
	},
	game: {
		_path: '/games/play',
		article: 'canonical'
	}
};

/***/ }),

/***/ 406:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = serialAND;
/* harmony export (immutable) */ __webpack_exports__["b"] = serialOR;

/**
 * Returns a Promise that iterates serially over an array of elements converting them to Promises on-demand
 * via the mapFunc and returning an array of all results upon completion.
 *
 * This function allows Promises to be built on-demand using the elements and mapFunc as the function iterates
 * over each array entry. The continueFunc allows you to decide upon resolving a Promise if you want to
 * continue iterating or return results now.
 *
 * @param {Array} elements An array of values. Each value will be passed to the mapFunc as serial iteration occurs.
 * @param {Function} mapFunc A function executed for each serial iteration receiving the arg at the index.
 * The function can return a value or a Promise that will be treated as it's result for the iteration.
 * @param {Function} continueFunc A function executed once each iteration is resolved. The result of the
 * iteration is passed in as an argument, and the function must return true|false. true indicates that
 * it will continue to iterate, false will break the iteration.
 * @returns A Promise the resolves to an array of all of the values resolved from each iteration.
 */
function serial(elements) {
  var mapFunc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (element) {
    return element;
  };
  var continueFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
    return true;
  };

  return new Promise(function (resolve) {
    var results = [];

    var mapFuncToPromise = function mapFuncToPromise(arg, mapFunc) {
      var r = mapFunc(arg);
      if (!r.then) r = Promise.resolve(r);
      return r;
    };

    var iterate = function iterate() {
      return mapFuncToPromise(elements[results.length], mapFunc).then(function (result) {
        results.push(result);
        return results.length < elements.length && continueFunc(result);
      }).then(function (iterateAgain) {
        return iterateAgain ? iterate() : resolve(results);
      });
    };

    iterate();
  });
}

/**
 * Builds Promises resolving to a boolean for each iteration of the elements array via mapFunc. As long as
 * each iteration keeps resolving to true, the iteration will continue. If an iteration resolves to false,
 * the iteration will cease and the result will be returned.
 *
 * @param {Array} elements An array of values. Each value will be passed to the mapFunc as serial iteration occurs.
 * @param {Function} mapFunc Must return a boolean or a Promise that resolves to a boolean.
 * @returns A Promise that resolves true if all iterations resulted in a true resolution.
 */
function serialAND(elements, mapFunc) {
  return serial(elements, mapFunc, function (result) {
    return !!result;
  }).then(function (results) {
    return !results.some(function (r) {
      return r === false;
    });
  });
}

/**
 * Builds Promises resolving to a boolean for each iteration of the elements array via mapFunc. As long as
 * each iteration keeps resolving to false, the iteration will continue. If an iteration resolves to true,
 * the iteration will cease and a true result will be returned.
 *
 * @param {Array} elements An array of values. Each value will be passed to the mapFunc as serial iteration occurs.
 * @param {Function} mapFunc Must return a boolean or a Promise that resolves to a boolean.
 * @returns A Promise that resolves true if one of the iterations resulted in a true resolution.
 */
function serialOR(elements, mapFunc) {
  return serial(elements, mapFunc, function (result) {
    return !result;
  }).then(function (results) {
    return results.some(function (r) {
      return r === true;
    });
  });
}

/***/ }),

/***/ 407:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Restriction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(369);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




/**
 * This component will only render its children if the supplied restriction condition
 * resolves true via isAllowed(condition).
 *
 * EG: <Restriction condition="authn">{//only renders if user is logged in}</Restriction>
 *
 * This component supports AND[] and OR{or:[]} as values for condition.
 *
 */

var Restriction = function (_Component) {
	_inherits(Restriction, _Component);

	function Restriction() {
		_classCallCheck(this, Restriction);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Restriction.prototype.checkRenderable = function checkRenderable() {
		var _this2 = this;

		var condition = this.props.condition,
		    canRenderCheck = condition ? Object(__WEBPACK_IMPORTED_MODULE_1____["b" /* default */])(condition, this.props, this.context) : true;


		if (canRenderCheck === false) {
			this.setState({ canRender: false });
			return;
		} else if (canRenderCheck.then) {
			this.setState({ checkingRenderability: true });
			canRenderCheck.then(function (canRender) {
				_this2.setState({ canRender: canRender, checkingRenderability: false });
				if (_this2.props.onResolved && canRender) _this2.props.onResolved();
			});
			return;
		}
		if (this.props.onResolved) this.props.onResolved();
		this.setState({ canRender: true });
	};

	Restriction.prototype.componentWillMount = function componentWillMount() {
		this.checkRenderable();
	};

	Restriction.prototype.render = function render(_ref, _ref2) {
		var children = _ref.children;
		var checkingRenderability = _ref2.checkingRenderability,
		    canRender = _ref2.canRender;

		if (checkingRenderability || !canRender) return null;
		return children && children[0];
	};

	return Restriction;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ 408:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAME; });
/* harmony export (immutable) */ __webpack_exports__["b"] = isAllowed;
/**
 * This local restriction adapter resolves true if we are running in a browser
 * that supports setting the page as the homepage.
 *
 * Specify restriction as:
 *
 *  canSetHomepage
 */

var NAME = 'canSetHomepage';

function isAllowed(_) {
	var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	    homepageFilters = _ref.homepageFilters;

	return Promise.resolve(shouldSetHomepageShow(homepageFilters));
}

function shouldSetHomepageShow(homepageFilters) {
	var checks = browserChecks();
	if (homepageFilters.hideSpanish && isSpanishPage()) {
		return false;
	}
	return homepageFilters.isFirefox === checks.isFirefox || homepageFilters.isSafari === checks.isSafari || homepageFilters.isIE === checks.isIE || homepageFilters.Edge === checks.isEdge || homepageFilters.isChrome === checks.isChrome;
}

/**
 * tests if browser is Firefox/Safari/IE/Edge/Chrome
 * src: stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser
 */
function browserChecks() {
	return {
		isFirefox: typeof InstallTrigger !== 'undefined',
		isSafari: /constructor/i.test(window.HTMLElement) || function (p) {
			return p.toString() === '[object SafariRemoteNotification]';
		}(!window.safari || typeof safari !== 'undefined' && window.safari.pushNotification),
		isIE: /*@cc_on!@*/false || !!document.documentMode,
		isEdge: /*@cc_on!@*/false || !!document.documentMode && !!window.StyleMedia,
		isChrome: !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime)
	};
}

/**
 * checks cookies && href to determine is user is on spanish page
 */
function isSpanishPage() {
	return document.cookie.includes && document.cookie.includes('es-us') || location.href.includes && location.href.includes('lang=es-us');
}

/***/ }),

/***/ 409:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAME; });
/* harmony export (immutable) */ __webpack_exports__["b"] = isAllowed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dlv__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dlv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dlv__);
/**
 * This is a local restriction adapter that resolves true or false
 * depending on the device type as specified by DeviceVariance. If
 * a DeviceVariance drops the device type into the context, we
 * can check it and resolve the restriction.
 *
 * The restriction can be defined to have a list of whitelisted
 * device values:
 *
 * device:phone,tablet
 *
 */


var NAME = '^device:(.+)$';

// The default value if the device is not actually defined in context.
var resultIfNoDevice = true;

function isAllowed(restriction, _) {
  var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var match = restriction.match(NAME);
  var result = context.device || __WEBPACK_IMPORTED_MODULE_0_dlv___default()(window, 'Syn.Config.Framework.device', '').split('|')[0] || resultIfNoDevice;
  if (match.length > 1) {
    result = match[1].split(',').map(function (key) {
      return key.trim();
    }).some(function (key) {
      return key === result;
    });
  }
  return result;
}

/***/ }),

/***/ 410:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAME; });
/* harmony export (immutable) */ __webpack_exports__["b"] = isAllowed;
/**
 * A restriction adapter used for testing primarily.
 * Will not resolve true until the specified time in ms passes.
 *
 * Define the restriction like so for a 5 second delay:
 *
 * delay:5000
 */

var NAME = '^delay:(.+)$';

function isAllowed(restriction) {
	var _restriction$match = restriction.match(NAME),
	    match = _restriction$match[1];

	if (match) {
		var duration = parseInt(match, 10);
		if (!isNaN(duration)) {
			return new Promise(function (resolve) {
				setTimeout(function () {
					return resolve(true);
				}, duration);
			});
		}
	}
	return Promise.resolve(true);
}

/***/ }),

/***/ 411:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAME; });
/* harmony export (immutable) */ __webpack_exports__["b"] = isAllowed;
/**
 * A restriction adapter That lets you specify a true or false resolution for debugging.
 * You can also include an optional message that will be printed to the console when the
 * restriction resolves.
 *
 * "debug:true:This message will be printed in the console"
 * "debug:false:This message will also be printed in the console"
 */

var NAME = '^debug:(.+?)(:(.+))?$';

function isAllowed(restriction) {
  var _restriction$match = restriction.match(NAME),
      result = _restriction$match[1],
      message = _restriction$match[3];

  if (message) console.log(message); //eslint-disable-line no-console
  return Promise.resolve(result === 'true');
}

/***/ }),

/***/ 412:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAME; });
/* unused harmony export clearCache */
/* harmony export (immutable) */ __webpack_exports__["b"] = isAllowed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cube_framework_service__ = __webpack_require__(413);
/**
 * This restriction adapter is for checking Gen4 restrictions and utilizing them
 * within Cube. Gen4 restrictions will be specified like this:
 *
 * restriction://Synacor/Portal/Restriction/Constant/Allow/
 * restriction://Synacor/Portal/Restriction/Constant/Deny/
 *
 * Note that each restriction resolution is cached and can only be cleared
 * by using clearCache().
 */



var NAME = 'restriction://(.+)$';

/**
 * Will store all pending and completed calls:
 */
var CACHE = {};

/**
 * Clear all cached restriction resolutions or
 * delete a specific one:
 * @param [String] restriction - An optional restriction to remove without clearing all.
 */
function clearCache(restriction) {
	if (restriction) {
		delete CACHE[restriction];
	} else {
		CACHE = {};
	}
}

function isAllowed(restriction) {
	if (!CACHE[restriction]) {
		CACHE[restriction] = Object(__WEBPACK_IMPORTED_MODULE_0__cube_framework_service__["a" /* default */])('restriction', { uri: restriction }, {}, true)
		// Ensure response is a boolean true value:
		.then(function (response) {
			CACHE[restriction] = response === true;
			return CACHE[restriction];
		})
		// If error occurs, just return false:
		.catch(function () {
			CACHE[restriction] = false;
			return CACHE[restriction];
		});
	}
	return CACHE[restriction];
}

/***/ }),

/***/ 413:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = service;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fetch_jsonp__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dlv__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dlv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_dlv__);
/* global Syn */




/* global CLIENT,CONFIG */

// Ultimate fallback inline values when no option or config value exists for a key
var FALLBACK = {
	client:  true ? "default" : 'aperture',
	site:  true ? "default" + '-gen4' : 'aperture-gen4',
	portalOrigin: __WEBPACK_IMPORTED_MODULE_2_dlv___default()(window, 'Syn.Config.Framework.PortalRoot') || 'http://aperture.synacor.net/',
	portalAppServer: __WEBPACK_IMPORTED_MODULE_2_dlv___default()(window, 'Syn.Config.Framework.AppServer') || 'appserv.jade.synacor.com'
};

// implements the simple fallback scheme giving precidence to an options object, then global config, then inline defaults
var cfg = function cfg(opts, key) {
	return opts[key] || typeof {"defaultLocale":"en","useBrowserLocale":true,"insulateRenderExceptions":{"insulate":true,"ignoreStateless":true},"streamApiOrigin":"https://content-stream.imds-api.com/","weatherServiceOrigin":"https://weather.imds-api.com","locationServiceOrigin":"https://location.imds-api.com","startContentServiceOrigin":"https://scs.imds-api.com","clientId":"synacor","streamClient":"aperture","useGracenoteAPI":true,"taboolaConfig":{"url":"https://api.taboola.com/1.2/json/","client":"synacor-synacor","endpoint":"recommendations.get","apikey":"1072f6b2b50d5e2d80cee9f2608d28b39e29bce5"},"components":{"a11y":"@cube/a11y","dcc2":"@cube/dcc-widget-v2","finance":"@cube/finance-components","header":"@cube/header-widget","layout":"@cube/layout","notifications":"@cube/notifications","performance":"@cube/performance","privacy":"@cube/privacy-widgets","singlecube":"@cube/single-cube","tvgrid2":"@cube/tv-grid-v2","video3":"@cube/video-widgets-v3","weather":"@cube/weather-widget"},"syncComponents":{},"lazyComponents":{"notifications":{"height":0},"finance.StockTickerBar":{"height":0},"sports.default":{"height":101},"navigation.Tertiary":{"height":20}},"resetScrollOnNavigate":true,"authnConfig":{"logout":{"url":"/logout"}},"weatherWidgetConfig":{"weatherLink":"http://www.accuweather.com","trackingParams":"partner=synacor&utm_source=synacor","showFiveDay":true,"useWeatherChannel":true,"storage_name":"weather-component","radarFullForecastWeatherURL":"http://www.accuweather.com/?partner=synacor&utm_source=synacor_synacor","forecastEndpoint":"wc/forecast/zipcode","weatherUrl":"https://www.accuweather.com/en/us/united-states-weather/?partner=synacor&utm_source=synacor_synacor","weatherPath":"","weatherVerticalUrl":"/weather/","alertConfig":{"weatherAlertNativeURL":"/weather/alerts","weatherAlertWeatherURL":"https://www.accuweather.com/en/us/united-states-weather/?partner=synacor&utm_source=synacor_synacor","weatherAlertWeatherPath":":4:","weatherAlertLevels":{"none":false,"minor":true,"moderate":true,"high":true,"severe":true,"extreme":true}}},"tvGridConfig":{"dontMissStations":["abc","nbc","cbs","fox","hbo","hgtv","tnt","espn","tbs","amc","usa","food"]},"tracking":{"capturing":["genericClick"],"reporting":{"adapters":[{"name":"trackgif","priorityMinimum":"low"},{"name":"google","priorityMinimum":"high"}]},"google":{"baseUrl":"https://www.googletagmanager.com/gtag/js?id="}},"search":{"google":{"searchURL":"/search/index.php","googleSearchURL":"https://www.google.com/search","queryParameter":"q","showSuggestions":false},"amazon":{"searchURL":"https://www.amazon.com/s/","queryParameter":"field-keywords","hiddenParameters":[{"name":"link_code","value":"wsw"},{"name":"_encoding","value":"UTF-8"},{"name":"search-alias","value":"aps"},{"name":"tag","value":"syn-aperture-gen4-header-20"}]},"ebay":{"searchURL":"https://rover.ebay.com/rover/1/711-53200-19255-0/1","queryParameter":"ext","hiddenParameters":[{"name":"campid","value":"5336146727"},{"name":"satitle","value":""},{"name":"type","value":"3"},{"name":"toolid","value":"10001"}]},"ask":{"limit":3,"matchType":"prefix","enableHighlighting":1,"host":"//synacor-amg-ss.ask.com/query"}},"privacyWidgetsConfig":{"overrideVersion":"20201123","ccpa":{"links":{"aboutOurAds":{"text":"About Our Ads","url":"/ad/about/"},"main":{"text":"Do Not Sell My Personal Information","url":"/ccpa"},"data":{"text":"Personal Data Download & Deletion","url":"/ccpa/data"},"partners":{"text":"Data Partners","url":"/ccpa/partners"},"privacy":{"text":"Privacy Page","url":"/privacy"}}}},"headerWidget":{"showSpecial":true,"condensed":false,"allowHideNavigation":true,"fixedToTop":true,"placeholdHeight":true,"track":true,"search":{"forceFocus":true},"linkEvent":{"track":{"eventActionMapping":{"default":"navigate","external":"navigate"}},"canRenderLink":{"homepageFilters":{"isSafari":true,"isChrome":true,"isIE":true,"isEdge":true,"isFirefox":true,"hideSpanish":true}}},"mobile":{"userMenu":{"settings":{"backButton":{"iconName":"navigate-left-cube","descriptionId":"mobile.userMenu.settings.back.description","event":"closeSettings"}},"closeButton":{"iconName":"close-cube","class":"closeMenu","descriptionId":"mobile.userMenu.close.description","event":"closeMenu"}},"primaryLinks":[],"navigationLinks":[{"labelId":"navigationLinks.home","url":"/","currentWhen":"^/?$"},{"labelId":"navigationLinks.tvmovies","url":"/video","currentWhen":"(^/video)|(^/tvschedule)","subnavWhen":"(^/video)|(^/tvschedule)","subnav":[{"labelId":"navigationLinks.tvmovies-featured","url":"/video","currentWhen":"^/video/?$"},{"labelId":"navigationLinks.tvmovies-schedule","url":"/tvschedule"},{"label":"Networks","url":"/video/networks","currentWhen":"^/video/networks"},{"label":"Sports","url":"/video/sports","currentWhen":"^/video/sports"}]},{"labelId":"navigationLinks.news","url":"/vertical/category/news/","currentWhen":"(^/(vertical|browse)/category/(news|us|world|politics|health|science))","subnavWhen":"(^/(vertical|browse)/category/(news|us|world|politics|health|science))","subnav":[{"labelId":"navigationLinks.news-topstories","url":"/vertical/category/news/"},{"labelId":"navigationLinks.news-us","url":"/browse/category/us/"},{"labelId":"navigationLinks.news-world","url":"/browse/category/world/"},{"labelId":"navigationLinks.news-politics","url":"/browse/category/politics/"},{"labelId":"navigationLinks.news-tech","url":"/browse/category/techbusiness/"},{"label":"Health","url":"/browse/category/health/"},{"label":"Science","url":"/browse/category/science/"}]},{"labelId":"navigationLinks.sports","url":"/vertical/category/sports/","currentWhen":"(^/(vertical|browse)/category/(sports|nfl|mlb|nba|nhl|college|soccer|golf|racing))","subnavWhen":"(^/(vertical|browse)/category/(sports|nfl|mlb|nba|nhl|college|soccer|golf|racing))","subnav":[{"labelId":"navigationLinks.sports-topstories","url":"/vertical/category/sports/"},{"labelId":"navigationLinks.sports-nfl","url":"/browse/category/nfl/"},{"labelId":"navigationLinks.sports-mlb","url":"/browse/category/mlb/"},{"labelId":"navigationLinks.sports-nba","url":"/browse/category/nba/"},{"labelId":"navigationLinks.sports-nhl","url":"/browse/category/nhl/"},{"label":"College","url":"/browse/category/college/"},{"label":"Soccer","url":"/browse/category/soccer/"},{"label":"Golf","url":"/browse/category/golf/"},{"label":"Racing","url":"/browse/category/racing/"}]},{"labelId":"navigationLinks.finance","url":"/finance/","currentWhen":"(^/(browse)/category/(business|techbusiness)|^/finance)","subnavWhen":"(^/(browse)/category/(business|techbusiness)|^/finance)","subnav":[{"labelId":"navigationLinks.finance-topstories","url":"/finance/","currentWhen":"^/finance/?$"},{"labelId":"navigationLinks.finance-business","url":"/browse/category/business/"},{"labelId":"navigationLinks.finance-markets","url":"/finance/category/markets/"},{"labelId":"navigationLinks.news-tech","url":"/browse/category/techbusiness/"},{"labelId":"navigationLinks.finance-press","url":"/finance/category/press"}]},{"labelId":"navigationLinks.entertainment","url":"/vertical/category/entertainment/","currentWhen":"(^/(vertical|browse)/category/(entertainment|movies|tv|celebrity|lifestyle))","subnavWhen":"(^/(vertical|browse)/category/(entertainment|movies|tv|celebrity|lifestyle))","subnav":[{"label":"Top Stories","url":"/vertical/category/entertainment/"},{"label":"Movies","url":"/browse/category/movies/"},{"label":"TV","url":"/browse/category/tv/"},{"label":"Celebrity","url":"/browse/category/celebrity/"},{"label":"Lifestyle","url":"/browse/category/lifestyle/"}]},{"labelId":"navigationLinks.games","url":"/vertical/category/games","currentWhen":"(^/(vertical|browse)/category/(games|cardgames|wordgames|strategygames|arcadegames)|(^/games))","subnavWhen":"(^/(vertical|browse)/category/(games|cardgames|wordgames|strategygames|arcadegames)|(^/games))","subnav":[{"labelId":"navigationLinks.games-all","url":"/vertical/category/games"},{"labelId":"navigationLinks.games-card","url":"/browse/category/cardgames"},{"labelId":"navigationLinks.games-word","url":"/browse/category/wordgames"},{"labelId":"navigationLinks.games-strategy","url":"/browse/category/strategygames"},{"labelId":"navigationLinks.games-arcade","url":"/browse/category/arcadegames"}]},{"label":"Leisure","url":"/vertical/category/leisure/","currentWhen":"(^/(vertical|browse)/category/(leisure|foodanddrink|travel|homeandgarden))","subnavWhen":"(^/(vertical|browse)/category/(leisure|foodanddrink|travel|homeandgarden))","subnav":[{"label":"Top Stories","url":"/vertical/category/leisure/"},{"label":"Food & Drink","url":"/browse/category/foodanddrink/"},{"label":"Travel","url":"/browse/category/travel/"},{"label":"Home & Garden","url":"/browse/category/homeandgarden/"}]}]},"desktop":{"useLargeLogo":true,"primaryLinks":[],"tophatDefaultContentConfig":{"topSearchesLabel":"Top Searches:","skinny":false},"footer":{"linkColumnMaxItems":3}},"logo":{"labelId":"logo.label","url":"/"},"auth":{"links":{"login":{"labelId":"auth.login","icon":true,"iconName":"login","event":"login"},"logout":{"labelId":"auth.logout","icon":true,"iconName":"logout","event":"logout"},"userLinks":[]}},"navigationLinks":[{"labelId":"navigationLinks.home","url":"/","currentWhen":"^/?$"},{"labelId":"navigationLinks.tvmovies","url":"/video","currentWhen":"(^/video)|(^/tvschedule)","subnavWhen":"(^/video)|(^/tvschedule)","subnav":[{"labelId":"navigationLinks.tvmovies-featured","url":"/video","currentWhen":"^/video/?$"},{"labelId":"navigationLinks.tvmovies-schedule","url":"/tvschedule"},{"label":"Networks","url":"/video/networks","currentWhen":"^/video/networks"},{"label":"Sports","url":"/video/sports","currentWhen":"^/video/sports"}]},{"labelId":"navigationLinks.news","url":"/vertical/category/news/","currentWhen":"(^/(vertical|browse)/category/(news|us|world|politics|health|science))","subnavWhen":"(^/(vertical|browse)/category/(news|us|world|politics|health|science))","subnav":[{"labelId":"navigationLinks.news-topstories","url":"/vertical/category/news/"},{"labelId":"navigationLinks.news-us","url":"/browse/category/us/"},{"labelId":"navigationLinks.news-world","url":"/browse/category/world/"},{"labelId":"navigationLinks.news-politics","url":"/browse/category/politics/"},{"labelId":"navigationLinks.news-tech","url":"/browse/category/techbusiness/"},{"label":"Health","url":"/browse/category/health/"},{"label":"Science","url":"/browse/category/science/"}]},{"labelId":"navigationLinks.sports","url":"/vertical/category/sports/","currentWhen":"(^/(vertical|browse)/category/(sports|nfl|mlb|nba|nhl|college|soccer|golf|racing))","subnavWhen":"(^/(vertical|browse)/category/(sports|nfl|mlb|nba|nhl|college|soccer|golf|racing))","subnav":[{"labelId":"navigationLinks.sports-topstories","url":"/vertical/category/sports/"},{"labelId":"navigationLinks.sports-nfl","url":"/browse/category/nfl/"},{"labelId":"navigationLinks.sports-mlb","url":"/browse/category/mlb/"},{"labelId":"navigationLinks.sports-nba","url":"/browse/category/nba/"},{"labelId":"navigationLinks.sports-nhl","url":"/browse/category/nhl/"},{"label":"College","url":"/browse/category/college/"},{"label":"Soccer","url":"/browse/category/soccer/"},{"label":"Golf","url":"/browse/category/golf/"},{"label":"Racing","url":"/browse/category/racing/"}]},{"labelId":"navigationLinks.finance","url":"/finance/","currentWhen":"(^/(browse)/category/(business|techbusiness)|^/finance)","subnavWhen":"(^/(browse)/category/(business|techbusiness)|^/finance)","subnav":[{"labelId":"navigationLinks.finance-topstories","url":"/finance/","currentWhen":"^/finance/?$"},{"labelId":"navigationLinks.finance-business","url":"/browse/category/business/"},{"labelId":"navigationLinks.finance-markets","url":"/finance/category/markets/"},{"labelId":"navigationLinks.news-tech","url":"/browse/category/techbusiness/"},{"labelId":"navigationLinks.finance-press","url":"/finance/category/press"}]},{"labelId":"navigationLinks.entertainment","url":"/vertical/category/entertainment/","currentWhen":"(^/(vertical|browse)/category/(entertainment|movies|tv|celebrity|lifestyle))","subnavWhen":"(^/(vertical|browse)/category/(entertainment|movies|tv|celebrity|lifestyle))","subnav":[{"label":"Top Stories","url":"/vertical/category/entertainment/"},{"label":"Movies","url":"/browse/category/movies/"},{"label":"TV","url":"/browse/category/tv/"},{"label":"Celebrity","url":"/browse/category/celebrity/"},{"label":"Lifestyle","url":"/browse/category/lifestyle/"}]},{"labelId":"navigationLinks.games","url":"/vertical/category/games","currentWhen":"(^/(vertical|browse)/category/(games|cardgames|wordgames|strategygames|arcadegames)|(^/games))","subnavWhen":"(^/(vertical|browse)/category/(games|cardgames|wordgames|strategygames|arcadegames)|(^/games))","subnav":[{"labelId":"navigationLinks.games-all","url":"/vertical/category/games"},{"labelId":"navigationLinks.games-card","url":"/browse/category/cardgames"},{"labelId":"navigationLinks.games-word","url":"/browse/category/wordgames"},{"labelId":"navigationLinks.games-strategy","url":"/browse/category/strategygames"},{"labelId":"navigationLinks.games-arcade","url":"/browse/category/arcadegames"}]},{"label":"Leisure","url":"/vertical/category/leisure/","currentWhen":"(^/(vertical|browse)/category/(leisure|foodanddrink|travel|homeandgarden))","subnavWhen":"(^/(vertical|browse)/category/(leisure|foodanddrink|travel|homeandgarden))","subnav":[{"label":"Top Stories","url":"/vertical/category/leisure/"},{"label":"Food & Drink","url":"/browse/category/foodanddrink/"},{"label":"Travel","url":"/browse/category/travel/"},{"label":"Home & Garden","url":"/browse/category/homeandgarden/"}]}],"nonClientLinks":[],"clientLinks":[],"leadingLinks":[],"footer":{"links":[],"altLinks":[],"affiliateLinks":[]}},"singleCube":{"taboolaInArticleSettings":{"placement":"Mid Article Thumbnails","mode":"thumbnails-md"},"pages":{"home":{"pageRefreshMinutes":15,"useTaboolaFeatured":true,"promoBanner":{"bufferMinutes":10080,"id":"ieDemise","mainText":"Support for IE11 is ending.","subText":"This site will no longer support your browser. Please upgrade to a newer browser like Microsoft Edge to continue to use this site.","buttons":[{"text":"Get Edge","url":"https://www.microsoft.com/en-us/edge"}],"ieOnly":true},"taboola":{"subDcc":{"taboolaJsParams":{"mode":"thumbnails-b-v2","container":"taboola-subdcc","placement":"SubDCC V2","target_type":"mix"},"id":"taboola-subdcc"},"rightRailBelowWeather":{"taboolaJsParams":{"mode":"thumbnails-c-v2","container":"taboola-1x4-right-rail-stream-ui","placement":"Right-rail Stream V2","target_type":"mix"},"id":"taboola-1x4-right-rail-stream-ui"},"featured":{"taboolaJsParams":{"mode":"organic-hp-sf-1X6-strip","container":"taboola-homepage-main-section","placement":"Homepage Main Section","target_type":"mix"},"id":"taboola-homepage-main-section"},"bottomPage":{"taboolaJsParams":{"mode":"thumbnails-hero-a-01","container":"taboola-bottom-thumbnails-unit","placement":"Bottom Thumbnails Unit","target_type":"mix"},"id":"taboola-bottom-thumbnails-unit"}},"clusters":{"dcc":{"cardSize":"medium-16:9","overlayMode":"desktop"},"recommended":{"defaultFeed":"featured","customizeKey":"home-recommended","taboolaNewsroomTag":"featured_cluster_desktop_v2","dmLocation":{"zone1":false,"zone2":true,"zone3":false}},"latestEntertainment":{"feed":"gen4_sc_entertainment","title":"Latest In Entertainment","imageCategory":"entertainment","taboolaNewsroomTag":"entertainment_cluster_desktop_v2","link":{"url":"/vertical/category/entertainment","label":"Browse Entertainment"},"verticalCardCount":3,"dmPlaylist":"x768fh","dmLocation":{"zone1":false,"zone2":true,"zone3":false}},"latestTrailers":{"feed":"gen4_sc_interesting_videos","title":"Interesting Videos","imageCategory":"entertainment","imageRole":"w=256,h=144","rowCount":3,"columnCount":2,"titleLines":4},"latestNews":{"feed":"gen4_sc_news","title":"Latest In News","imageCategory":"news","taboolaNewsroomTag":"news_cluster_desktop_v2","link":{"url":"/vertical/category/news","label":"Browse News"},"dmPlaylist":"x768c3","dmLocation":{"zone1":false,"zone2":true,"zone3":false}},"latestSports":{"feed":"gen4_sc_sports","title":"Latest In Sports","imageCategory":"sports","taboolaNewsroomTag":"sports_cluster_desktop_v2","link":{"url":"/vertical/category/sports","label":"Browse Sports"},"dmPlaylist":"x768c4","dmLocation":{"zone1":false,"zone2":true,"zone3":false}},"sportsVideos":{"feed":"gen4_sc_games","title":"Popular Games","imageRole":"w=256,h=144","rowCount":3,"columnCount":2,"link":{"url":"/vertical/category/games","label":"Browse Games"},"attributionOverride":"Play Now"},"latestBusiness":{"feed":"gen4_sc_business","title":"Latest In Business","imageCategory":"business","taboolaNewsroomTag":"business_cluster_desktop_v2","link":{"url":"/finance","label":"Browse Business"},"dmPlaylist":"x7603s","dmLocation":{"zone1":false,"zone2":true,"zone3":false}}}},"read":{"taboola":{"rightRail":{"taboolaJsParams":{"mode":"thumbnails-d-v2","container":"taboola-1x4-right-rail-landscape-ui","placement":"Right-rail Landscape V2","target_type":"mix"},"id":"taboola-1x4-right-rail-landscape-ui"},"belowText":{"taboolaJsParams":{"mode":"thumbnails-e-v2","container":"taboola-finite-feed","placement":"Finite Feed V2","target_type":"mix"},"id":"taboola-finite-feed"}},"clusters":{"slideshows":{"feed":"gen4_sc_slideshows","title":"Popular Slideshows","imageCategory":"entertainment","imageRole":"w=256,h=144","rowCount":1,"columnCount":4}}},"readPhone":{"taboola":{"belowText":{"taboolaJsParams":{"mode":"thumbnails-e-v2","container":"taboola-finite-feed","placement":"Finite Feed V2","target_type":"mix"},"id":"taboola-finite-feed"}},"clusters":{"slideshows":{"feed":"gen4_sc_slideshows","title":"Popular Slideshows","imageCategory":"entertainment","imageRole":"w=256,h=144","rowCount":3,"columnCount":2}}},"videoHome":{"theme":"dark","taboola":{"rightRail":{"taboolaJsParams":{"mode":"thumbnails-RR-Vid","container":"taboola-right-rail---tv_movies","placement":"Right Rail - TV_Movies","target_type":"mix"},"id":"taboola-right-rail---tv_movies"}},"clusters":{"featuredShoppingNetworks":{"title":"Featured Shopping Networks","showScheduleUrl":false,"shuffle":false,"networks":[{"logo":"https://vam-image.imds-cdn.com/21/16/21165c8f17ddbb7083d95fcb22c1f1644d327a5c","link":"https://www.shophq.com/onair/watchuslive?cm_re=GN-_-ONAIR-_-WATCHUSLIVE","name":"ShopHQ"},{"logo":"https://vam-image.imds-cdn.com/a8/0d/a80dffde690a495c1d32ce5b1f2711680ffea772","link":"https://www.bulldogshoppingnetwork.com/onair/WatchUsLive?cm_re=GN-_-ONAIR-_-WATCHUSLIVE","name":"Shop Bulldog TV"},{"logo":"https://vam-image.imds-cdn.com/07/b5/07b539b344707f5e0e5d6436e84253f7f47d3357","link":"https://www.shophqhealth.com/onair/WatchUsLive?cm_re=GN-_-ONAIR-_-WATCHUSLIVE","name":"ShopHQ Health"},{"logo":"https://vam-image.imds-cdn.com/11/65/11651762babe144c250bc720f7bc82e8e19f902f","link":"https://www.imediabrands.com/laventa/","name":"Shop LaVenta"}]},"featuredRightRail":{"title":"Featured Trailers","imageCategory":"entertainment","imageRole":"w=256,h=144","rowCount":3,"columnCount":2,"titleLines":3,"isDailyMotion":true,"dmPlaylist":"x7apbk","link":{"url":"/browse/category/trailers","label":"More"}},"latestEntertainment":{"feed":"gen4_sc_entertainment","title":"Latest In Entertainment","imageCategory":"entertainment","link":{"url":"/vertical/category/entertainment","label":"Browse Entertainment"}},"insticator":{"src":"https://d3lcz8vpax4lo2.cloudfront.net/ads-code/bc14a653-a25e-4c6c-a789-046f73e18929.js","loaderSrc":"https://product.instiengage.com/product-loader-code/bc14a653-a25e-4c6c-a789-046f73e18929.js","id":"d0027fb9-60e7-4686-9b3e-50eec10998dc","showAd4":"above"}},"footer":{"theme":"dark"}},"videoMovieDetails":{"theme":"dark","taboola":{"rightRail":{"taboolaJsParams":{"mode":"thumbnails-RR-Vid","container":"taboola-right-rail---tv_movies","placement":"Right Rail - TV_Movies","target_type":"mix"},"id":"taboola-right-rail---tv_movies"}},"clusters":{"insticator":{"src":"https://d3lcz8vpax4lo2.cloudfront.net/ads-code/bc14a653-a25e-4c6c-a789-046f73e18929.js","loaderSrc":"https://product.instiengage.com/product-loader-code/bc14a653-a25e-4c6c-a789-046f73e18929.js","id":"9e5b5f86-b232-4c99-b9f3-81c7dbd247f2","showAd1":"below"}},"footer":{"theme":"dark"}},"videoSeriesDetails":{"theme":"dark","taboola":{"rightRail":{"taboolaJsParams":{"mode":"thumbnails-RR-Vid","container":"taboola-right-rail---tv_movies","placement":"Right Rail - TV_Movies","target_type":"mix"},"id":"taboola-right-rail---tv_movies"}},"clusters":{"insticator":{"src":"https://d3lcz8vpax4lo2.cloudfront.net/ads-code/bc14a653-a25e-4c6c-a789-046f73e18929.js","loaderSrc":"https://product.instiengage.com/product-loader-code/bc14a653-a25e-4c6c-a789-046f73e18929.js","id":"9e5b5f86-b232-4c99-b9f3-81c7dbd247f2","showAd1":"below"}},"footer":{"theme":"dark"}},"videoEpisodeDetails":{"theme":"dark","taboola":{"rightRail":{"taboolaJsParams":{"mode":"thumbnails-RR-Vid","container":"taboola-right-rail---tv_movies","placement":"Right Rail - TV_Movies","target_type":"mix"},"id":"taboola-right-rail---tv_movies"}},"clusters":{"insticator":{"src":"https://d3lcz8vpax4lo2.cloudfront.net/ads-code/bc14a653-a25e-4c6c-a789-046f73e18929.js","loaderSrc":"https://product.instiengage.com/product-loader-code/bc14a653-a25e-4c6c-a789-046f73e18929.js","id":"9e5b5f86-b232-4c99-b9f3-81c7dbd247f2","showAd1":"below"}},"footer":{"theme":"dark"}}}}} !== 'undefined' && {"defaultLocale":"en","useBrowserLocale":true,"insulateRenderExceptions":{"insulate":true,"ignoreStateless":true},"streamApiOrigin":"https://content-stream.imds-api.com/","weatherServiceOrigin":"https://weather.imds-api.com","locationServiceOrigin":"https://location.imds-api.com","startContentServiceOrigin":"https://scs.imds-api.com","clientId":"synacor","streamClient":"aperture","useGracenoteAPI":true,"taboolaConfig":{"url":"https://api.taboola.com/1.2/json/","client":"synacor-synacor","endpoint":"recommendations.get","apikey":"1072f6b2b50d5e2d80cee9f2608d28b39e29bce5"},"components":{"a11y":"@cube/a11y","dcc2":"@cube/dcc-widget-v2","finance":"@cube/finance-components","header":"@cube/header-widget","layout":"@cube/layout","notifications":"@cube/notifications","performance":"@cube/performance","privacy":"@cube/privacy-widgets","singlecube":"@cube/single-cube","tvgrid2":"@cube/tv-grid-v2","video3":"@cube/video-widgets-v3","weather":"@cube/weather-widget"},"syncComponents":{},"lazyComponents":{"notifications":{"height":0},"finance.StockTickerBar":{"height":0},"sports.default":{"height":101},"navigation.Tertiary":{"height":20}},"resetScrollOnNavigate":true,"authnConfig":{"logout":{"url":"/logout"}},"weatherWidgetConfig":{"weatherLink":"http://www.accuweather.com","trackingParams":"partner=synacor&utm_source=synacor","showFiveDay":true,"useWeatherChannel":true,"storage_name":"weather-component","radarFullForecastWeatherURL":"http://www.accuweather.com/?partner=synacor&utm_source=synacor_synacor","forecastEndpoint":"wc/forecast/zipcode","weatherUrl":"https://www.accuweather.com/en/us/united-states-weather/?partner=synacor&utm_source=synacor_synacor","weatherPath":"","weatherVerticalUrl":"/weather/","alertConfig":{"weatherAlertNativeURL":"/weather/alerts","weatherAlertWeatherURL":"https://www.accuweather.com/en/us/united-states-weather/?partner=synacor&utm_source=synacor_synacor","weatherAlertWeatherPath":":4:","weatherAlertLevels":{"none":false,"minor":true,"moderate":true,"high":true,"severe":true,"extreme":true}}},"tvGridConfig":{"dontMissStations":["abc","nbc","cbs","fox","hbo","hgtv","tnt","espn","tbs","amc","usa","food"]},"tracking":{"capturing":["genericClick"],"reporting":{"adapters":[{"name":"trackgif","priorityMinimum":"low"},{"name":"google","priorityMinimum":"high"}]},"google":{"baseUrl":"https://www.googletagmanager.com/gtag/js?id="}},"search":{"google":{"searchURL":"/search/index.php","googleSearchURL":"https://www.google.com/search","queryParameter":"q","showSuggestions":false},"amazon":{"searchURL":"https://www.amazon.com/s/","queryParameter":"field-keywords","hiddenParameters":[{"name":"link_code","value":"wsw"},{"name":"_encoding","value":"UTF-8"},{"name":"search-alias","value":"aps"},{"name":"tag","value":"syn-aperture-gen4-header-20"}]},"ebay":{"searchURL":"https://rover.ebay.com/rover/1/711-53200-19255-0/1","queryParameter":"ext","hiddenParameters":[{"name":"campid","value":"5336146727"},{"name":"satitle","value":""},{"name":"type","value":"3"},{"name":"toolid","value":"10001"}]},"ask":{"limit":3,"matchType":"prefix","enableHighlighting":1,"host":"//synacor-amg-ss.ask.com/query"}},"privacyWidgetsConfig":{"overrideVersion":"20201123","ccpa":{"links":{"aboutOurAds":{"text":"About Our Ads","url":"/ad/about/"},"main":{"text":"Do Not Sell My Personal Information","url":"/ccpa"},"data":{"text":"Personal Data Download & Deletion","url":"/ccpa/data"},"partners":{"text":"Data Partners","url":"/ccpa/partners"},"privacy":{"text":"Privacy Page","url":"/privacy"}}}},"headerWidget":{"showSpecial":true,"condensed":false,"allowHideNavigation":true,"fixedToTop":true,"placeholdHeight":true,"track":true,"search":{"forceFocus":true},"linkEvent":{"track":{"eventActionMapping":{"default":"navigate","external":"navigate"}},"canRenderLink":{"homepageFilters":{"isSafari":true,"isChrome":true,"isIE":true,"isEdge":true,"isFirefox":true,"hideSpanish":true}}},"mobile":{"userMenu":{"settings":{"backButton":{"iconName":"navigate-left-cube","descriptionId":"mobile.userMenu.settings.back.description","event":"closeSettings"}},"closeButton":{"iconName":"close-cube","class":"closeMenu","descriptionId":"mobile.userMenu.close.description","event":"closeMenu"}},"primaryLinks":[],"navigationLinks":[{"labelId":"navigationLinks.home","url":"/","currentWhen":"^/?$"},{"labelId":"navigationLinks.tvmovies","url":"/video","currentWhen":"(^/video)|(^/tvschedule)","subnavWhen":"(^/video)|(^/tvschedule)","subnav":[{"labelId":"navigationLinks.tvmovies-featured","url":"/video","currentWhen":"^/video/?$"},{"labelId":"navigationLinks.tvmovies-schedule","url":"/tvschedule"},{"label":"Networks","url":"/video/networks","currentWhen":"^/video/networks"},{"label":"Sports","url":"/video/sports","currentWhen":"^/video/sports"}]},{"labelId":"navigationLinks.news","url":"/vertical/category/news/","currentWhen":"(^/(vertical|browse)/category/(news|us|world|politics|health|science))","subnavWhen":"(^/(vertical|browse)/category/(news|us|world|politics|health|science))","subnav":[{"labelId":"navigationLinks.news-topstories","url":"/vertical/category/news/"},{"labelId":"navigationLinks.news-us","url":"/browse/category/us/"},{"labelId":"navigationLinks.news-world","url":"/browse/category/world/"},{"labelId":"navigationLinks.news-politics","url":"/browse/category/politics/"},{"labelId":"navigationLinks.news-tech","url":"/browse/category/techbusiness/"},{"label":"Health","url":"/browse/category/health/"},{"label":"Science","url":"/browse/category/science/"}]},{"labelId":"navigationLinks.sports","url":"/vertical/category/sports/","currentWhen":"(^/(vertical|browse)/category/(sports|nfl|mlb|nba|nhl|college|soccer|golf|racing))","subnavWhen":"(^/(vertical|browse)/category/(sports|nfl|mlb|nba|nhl|college|soccer|golf|racing))","subnav":[{"labelId":"navigationLinks.sports-topstories","url":"/vertical/category/sports/"},{"labelId":"navigationLinks.sports-nfl","url":"/browse/category/nfl/"},{"labelId":"navigationLinks.sports-mlb","url":"/browse/category/mlb/"},{"labelId":"navigationLinks.sports-nba","url":"/browse/category/nba/"},{"labelId":"navigationLinks.sports-nhl","url":"/browse/category/nhl/"},{"label":"College","url":"/browse/category/college/"},{"label":"Soccer","url":"/browse/category/soccer/"},{"label":"Golf","url":"/browse/category/golf/"},{"label":"Racing","url":"/browse/category/racing/"}]},{"labelId":"navigationLinks.finance","url":"/finance/","currentWhen":"(^/(browse)/category/(business|techbusiness)|^/finance)","subnavWhen":"(^/(browse)/category/(business|techbusiness)|^/finance)","subnav":[{"labelId":"navigationLinks.finance-topstories","url":"/finance/","currentWhen":"^/finance/?$"},{"labelId":"navigationLinks.finance-business","url":"/browse/category/business/"},{"labelId":"navigationLinks.finance-markets","url":"/finance/category/markets/"},{"labelId":"navigationLinks.news-tech","url":"/browse/category/techbusiness/"},{"labelId":"navigationLinks.finance-press","url":"/finance/category/press"}]},{"labelId":"navigationLinks.entertainment","url":"/vertical/category/entertainment/","currentWhen":"(^/(vertical|browse)/category/(entertainment|movies|tv|celebrity|lifestyle))","subnavWhen":"(^/(vertical|browse)/category/(entertainment|movies|tv|celebrity|lifestyle))","subnav":[{"label":"Top Stories","url":"/vertical/category/entertainment/"},{"label":"Movies","url":"/browse/category/movies/"},{"label":"TV","url":"/browse/category/tv/"},{"label":"Celebrity","url":"/browse/category/celebrity/"},{"label":"Lifestyle","url":"/browse/category/lifestyle/"}]},{"labelId":"navigationLinks.games","url":"/vertical/category/games","currentWhen":"(^/(vertical|browse)/category/(games|cardgames|wordgames|strategygames|arcadegames)|(^/games))","subnavWhen":"(^/(vertical|browse)/category/(games|cardgames|wordgames|strategygames|arcadegames)|(^/games))","subnav":[{"labelId":"navigationLinks.games-all","url":"/vertical/category/games"},{"labelId":"navigationLinks.games-card","url":"/browse/category/cardgames"},{"labelId":"navigationLinks.games-word","url":"/browse/category/wordgames"},{"labelId":"navigationLinks.games-strategy","url":"/browse/category/strategygames"},{"labelId":"navigationLinks.games-arcade","url":"/browse/category/arcadegames"}]},{"label":"Leisure","url":"/vertical/category/leisure/","currentWhen":"(^/(vertical|browse)/category/(leisure|foodanddrink|travel|homeandgarden))","subnavWhen":"(^/(vertical|browse)/category/(leisure|foodanddrink|travel|homeandgarden))","subnav":[{"label":"Top Stories","url":"/vertical/category/leisure/"},{"label":"Food & Drink","url":"/browse/category/foodanddrink/"},{"label":"Travel","url":"/browse/category/travel/"},{"label":"Home & Garden","url":"/browse/category/homeandgarden/"}]}]},"desktop":{"useLargeLogo":true,"primaryLinks":[],"tophatDefaultContentConfig":{"topSearchesLabel":"Top Searches:","skinny":false},"footer":{"linkColumnMaxItems":3}},"logo":{"labelId":"logo.label","url":"/"},"auth":{"links":{"login":{"labelId":"auth.login","icon":true,"iconName":"login","event":"login"},"logout":{"labelId":"auth.logout","icon":true,"iconName":"logout","event":"logout"},"userLinks":[]}},"navigationLinks":[{"labelId":"navigationLinks.home","url":"/","currentWhen":"^/?$"},{"labelId":"navigationLinks.tvmovies","url":"/video","currentWhen":"(^/video)|(^/tvschedule)","subnavWhen":"(^/video)|(^/tvschedule)","subnav":[{"labelId":"navigationLinks.tvmovies-featured","url":"/video","currentWhen":"^/video/?$"},{"labelId":"navigationLinks.tvmovies-schedule","url":"/tvschedule"},{"label":"Networks","url":"/video/networks","currentWhen":"^/video/networks"},{"label":"Sports","url":"/video/sports","currentWhen":"^/video/sports"}]},{"labelId":"navigationLinks.news","url":"/vertical/category/news/","currentWhen":"(^/(vertical|browse)/category/(news|us|world|politics|health|science))","subnavWhen":"(^/(vertical|browse)/category/(news|us|world|politics|health|science))","subnav":[{"labelId":"navigationLinks.news-topstories","url":"/vertical/category/news/"},{"labelId":"navigationLinks.news-us","url":"/browse/category/us/"},{"labelId":"navigationLinks.news-world","url":"/browse/category/world/"},{"labelId":"navigationLinks.news-politics","url":"/browse/category/politics/"},{"labelId":"navigationLinks.news-tech","url":"/browse/category/techbusiness/"},{"label":"Health","url":"/browse/category/health/"},{"label":"Science","url":"/browse/category/science/"}]},{"labelId":"navigationLinks.sports","url":"/vertical/category/sports/","currentWhen":"(^/(vertical|browse)/category/(sports|nfl|mlb|nba|nhl|college|soccer|golf|racing))","subnavWhen":"(^/(vertical|browse)/category/(sports|nfl|mlb|nba|nhl|college|soccer|golf|racing))","subnav":[{"labelId":"navigationLinks.sports-topstories","url":"/vertical/category/sports/"},{"labelId":"navigationLinks.sports-nfl","url":"/browse/category/nfl/"},{"labelId":"navigationLinks.sports-mlb","url":"/browse/category/mlb/"},{"labelId":"navigationLinks.sports-nba","url":"/browse/category/nba/"},{"labelId":"navigationLinks.sports-nhl","url":"/browse/category/nhl/"},{"label":"College","url":"/browse/category/college/"},{"label":"Soccer","url":"/browse/category/soccer/"},{"label":"Golf","url":"/browse/category/golf/"},{"label":"Racing","url":"/browse/category/racing/"}]},{"labelId":"navigationLinks.finance","url":"/finance/","currentWhen":"(^/(browse)/category/(business|techbusiness)|^/finance)","subnavWhen":"(^/(browse)/category/(business|techbusiness)|^/finance)","subnav":[{"labelId":"navigationLinks.finance-topstories","url":"/finance/","currentWhen":"^/finance/?$"},{"labelId":"navigationLinks.finance-business","url":"/browse/category/business/"},{"labelId":"navigationLinks.finance-markets","url":"/finance/category/markets/"},{"labelId":"navigationLinks.news-tech","url":"/browse/category/techbusiness/"},{"labelId":"navigationLinks.finance-press","url":"/finance/category/press"}]},{"labelId":"navigationLinks.entertainment","url":"/vertical/category/entertainment/","currentWhen":"(^/(vertical|browse)/category/(entertainment|movies|tv|celebrity|lifestyle))","subnavWhen":"(^/(vertical|browse)/category/(entertainment|movies|tv|celebrity|lifestyle))","subnav":[{"label":"Top Stories","url":"/vertical/category/entertainment/"},{"label":"Movies","url":"/browse/category/movies/"},{"label":"TV","url":"/browse/category/tv/"},{"label":"Celebrity","url":"/browse/category/celebrity/"},{"label":"Lifestyle","url":"/browse/category/lifestyle/"}]},{"labelId":"navigationLinks.games","url":"/vertical/category/games","currentWhen":"(^/(vertical|browse)/category/(games|cardgames|wordgames|strategygames|arcadegames)|(^/games))","subnavWhen":"(^/(vertical|browse)/category/(games|cardgames|wordgames|strategygames|arcadegames)|(^/games))","subnav":[{"labelId":"navigationLinks.games-all","url":"/vertical/category/games"},{"labelId":"navigationLinks.games-card","url":"/browse/category/cardgames"},{"labelId":"navigationLinks.games-word","url":"/browse/category/wordgames"},{"labelId":"navigationLinks.games-strategy","url":"/browse/category/strategygames"},{"labelId":"navigationLinks.games-arcade","url":"/browse/category/arcadegames"}]},{"label":"Leisure","url":"/vertical/category/leisure/","currentWhen":"(^/(vertical|browse)/category/(leisure|foodanddrink|travel|homeandgarden))","subnavWhen":"(^/(vertical|browse)/category/(leisure|foodanddrink|travel|homeandgarden))","subnav":[{"label":"Top Stories","url":"/vertical/category/leisure/"},{"label":"Food & Drink","url":"/browse/category/foodanddrink/"},{"label":"Travel","url":"/browse/category/travel/"},{"label":"Home & Garden","url":"/browse/category/homeandgarden/"}]}],"nonClientLinks":[],"clientLinks":[],"leadingLinks":[],"footer":{"links":[],"altLinks":[],"affiliateLinks":[]}},"singleCube":{"taboolaInArticleSettings":{"placement":"Mid Article Thumbnails","mode":"thumbnails-md"},"pages":{"home":{"pageRefreshMinutes":15,"useTaboolaFeatured":true,"promoBanner":{"bufferMinutes":10080,"id":"ieDemise","mainText":"Support for IE11 is ending.","subText":"This site will no longer support your browser. Please upgrade to a newer browser like Microsoft Edge to continue to use this site.","buttons":[{"text":"Get Edge","url":"https://www.microsoft.com/en-us/edge"}],"ieOnly":true},"taboola":{"subDcc":{"taboolaJsParams":{"mode":"thumbnails-b-v2","container":"taboola-subdcc","placement":"SubDCC V2","target_type":"mix"},"id":"taboola-subdcc"},"rightRailBelowWeather":{"taboolaJsParams":{"mode":"thumbnails-c-v2","container":"taboola-1x4-right-rail-stream-ui","placement":"Right-rail Stream V2","target_type":"mix"},"id":"taboola-1x4-right-rail-stream-ui"},"featured":{"taboolaJsParams":{"mode":"organic-hp-sf-1X6-strip","container":"taboola-homepage-main-section","placement":"Homepage Main Section","target_type":"mix"},"id":"taboola-homepage-main-section"},"bottomPage":{"taboolaJsParams":{"mode":"thumbnails-hero-a-01","container":"taboola-bottom-thumbnails-unit","placement":"Bottom Thumbnails Unit","target_type":"mix"},"id":"taboola-bottom-thumbnails-unit"}},"clusters":{"dcc":{"cardSize":"medium-16:9","overlayMode":"desktop"},"recommended":{"defaultFeed":"featured","customizeKey":"home-recommended","taboolaNewsroomTag":"featured_cluster_desktop_v2","dmLocation":{"zone1":false,"zone2":true,"zone3":false}},"latestEntertainment":{"feed":"gen4_sc_entertainment","title":"Latest In Entertainment","imageCategory":"entertainment","taboolaNewsroomTag":"entertainment_cluster_desktop_v2","link":{"url":"/vertical/category/entertainment","label":"Browse Entertainment"},"verticalCardCount":3,"dmPlaylist":"x768fh","dmLocation":{"zone1":false,"zone2":true,"zone3":false}},"latestTrailers":{"feed":"gen4_sc_interesting_videos","title":"Interesting Videos","imageCategory":"entertainment","imageRole":"w=256,h=144","rowCount":3,"columnCount":2,"titleLines":4},"latestNews":{"feed":"gen4_sc_news","title":"Latest In News","imageCategory":"news","taboolaNewsroomTag":"news_cluster_desktop_v2","link":{"url":"/vertical/category/news","label":"Browse News"},"dmPlaylist":"x768c3","dmLocation":{"zone1":false,"zone2":true,"zone3":false}},"latestSports":{"feed":"gen4_sc_sports","title":"Latest In Sports","imageCategory":"sports","taboolaNewsroomTag":"sports_cluster_desktop_v2","link":{"url":"/vertical/category/sports","label":"Browse Sports"},"dmPlaylist":"x768c4","dmLocation":{"zone1":false,"zone2":true,"zone3":false}},"sportsVideos":{"feed":"gen4_sc_games","title":"Popular Games","imageRole":"w=256,h=144","rowCount":3,"columnCount":2,"link":{"url":"/vertical/category/games","label":"Browse Games"},"attributionOverride":"Play Now"},"latestBusiness":{"feed":"gen4_sc_business","title":"Latest In Business","imageCategory":"business","taboolaNewsroomTag":"business_cluster_desktop_v2","link":{"url":"/finance","label":"Browse Business"},"dmPlaylist":"x7603s","dmLocation":{"zone1":false,"zone2":true,"zone3":false}}}},"read":{"taboola":{"rightRail":{"taboolaJsParams":{"mode":"thumbnails-d-v2","container":"taboola-1x4-right-rail-landscape-ui","placement":"Right-rail Landscape V2","target_type":"mix"},"id":"taboola-1x4-right-rail-landscape-ui"},"belowText":{"taboolaJsParams":{"mode":"thumbnails-e-v2","container":"taboola-finite-feed","placement":"Finite Feed V2","target_type":"mix"},"id":"taboola-finite-feed"}},"clusters":{"slideshows":{"feed":"gen4_sc_slideshows","title":"Popular Slideshows","imageCategory":"entertainment","imageRole":"w=256,h=144","rowCount":1,"columnCount":4}}},"readPhone":{"taboola":{"belowText":{"taboolaJsParams":{"mode":"thumbnails-e-v2","container":"taboola-finite-feed","placement":"Finite Feed V2","target_type":"mix"},"id":"taboola-finite-feed"}},"clusters":{"slideshows":{"feed":"gen4_sc_slideshows","title":"Popular Slideshows","imageCategory":"entertainment","imageRole":"w=256,h=144","rowCount":3,"columnCount":2}}},"videoHome":{"theme":"dark","taboola":{"rightRail":{"taboolaJsParams":{"mode":"thumbnails-RR-Vid","container":"taboola-right-rail---tv_movies","placement":"Right Rail - TV_Movies","target_type":"mix"},"id":"taboola-right-rail---tv_movies"}},"clusters":{"featuredShoppingNetworks":{"title":"Featured Shopping Networks","showScheduleUrl":false,"shuffle":false,"networks":[{"logo":"https://vam-image.imds-cdn.com/21/16/21165c8f17ddbb7083d95fcb22c1f1644d327a5c","link":"https://www.shophq.com/onair/watchuslive?cm_re=GN-_-ONAIR-_-WATCHUSLIVE","name":"ShopHQ"},{"logo":"https://vam-image.imds-cdn.com/a8/0d/a80dffde690a495c1d32ce5b1f2711680ffea772","link":"https://www.bulldogshoppingnetwork.com/onair/WatchUsLive?cm_re=GN-_-ONAIR-_-WATCHUSLIVE","name":"Shop Bulldog TV"},{"logo":"https://vam-image.imds-cdn.com/07/b5/07b539b344707f5e0e5d6436e84253f7f47d3357","link":"https://www.shophqhealth.com/onair/WatchUsLive?cm_re=GN-_-ONAIR-_-WATCHUSLIVE","name":"ShopHQ Health"},{"logo":"https://vam-image.imds-cdn.com/11/65/11651762babe144c250bc720f7bc82e8e19f902f","link":"https://www.imediabrands.com/laventa/","name":"Shop LaVenta"}]},"featuredRightRail":{"title":"Featured Trailers","imageCategory":"entertainment","imageRole":"w=256,h=144","rowCount":3,"columnCount":2,"titleLines":3,"isDailyMotion":true,"dmPlaylist":"x7apbk","link":{"url":"/browse/category/trailers","label":"More"}},"latestEntertainment":{"feed":"gen4_sc_entertainment","title":"Latest In Entertainment","imageCategory":"entertainment","link":{"url":"/vertical/category/entertainment","label":"Browse Entertainment"}},"insticator":{"src":"https://d3lcz8vpax4lo2.cloudfront.net/ads-code/bc14a653-a25e-4c6c-a789-046f73e18929.js","loaderSrc":"https://product.instiengage.com/product-loader-code/bc14a653-a25e-4c6c-a789-046f73e18929.js","id":"d0027fb9-60e7-4686-9b3e-50eec10998dc","showAd4":"above"}},"footer":{"theme":"dark"}},"videoMovieDetails":{"theme":"dark","taboola":{"rightRail":{"taboolaJsParams":{"mode":"thumbnails-RR-Vid","container":"taboola-right-rail---tv_movies","placement":"Right Rail - TV_Movies","target_type":"mix"},"id":"taboola-right-rail---tv_movies"}},"clusters":{"insticator":{"src":"https://d3lcz8vpax4lo2.cloudfront.net/ads-code/bc14a653-a25e-4c6c-a789-046f73e18929.js","loaderSrc":"https://product.instiengage.com/product-loader-code/bc14a653-a25e-4c6c-a789-046f73e18929.js","id":"9e5b5f86-b232-4c99-b9f3-81c7dbd247f2","showAd1":"below"}},"footer":{"theme":"dark"}},"videoSeriesDetails":{"theme":"dark","taboola":{"rightRail":{"taboolaJsParams":{"mode":"thumbnails-RR-Vid","container":"taboola-right-rail---tv_movies","placement":"Right Rail - TV_Movies","target_type":"mix"},"id":"taboola-right-rail---tv_movies"}},"clusters":{"insticator":{"src":"https://d3lcz8vpax4lo2.cloudfront.net/ads-code/bc14a653-a25e-4c6c-a789-046f73e18929.js","loaderSrc":"https://product.instiengage.com/product-loader-code/bc14a653-a25e-4c6c-a789-046f73e18929.js","id":"9e5b5f86-b232-4c99-b9f3-81c7dbd247f2","showAd1":"below"}},"footer":{"theme":"dark"}},"videoEpisodeDetails":{"theme":"dark","taboola":{"rightRail":{"taboolaJsParams":{"mode":"thumbnails-RR-Vid","container":"taboola-right-rail---tv_movies","placement":"Right Rail - TV_Movies","target_type":"mix"},"id":"taboola-right-rail---tv_movies"}},"clusters":{"insticator":{"src":"https://d3lcz8vpax4lo2.cloudfront.net/ads-code/bc14a653-a25e-4c6c-a789-046f73e18929.js","loaderSrc":"https://product.instiengage.com/product-loader-code/bc14a653-a25e-4c6c-a789-046f73e18929.js","id":"9e5b5f86-b232-4c99-b9f3-81c7dbd247f2","showAd1":"below"}},"footer":{"theme":"dark"}}}}}[key] || FALLBACK[key];
};

// strip framework response down to just the data
var transformResponse = function transformResponse(r) {
	return r && r.init && r.init.data;
};

/** Call into the framework's service/proxy endpoint on appserv
 *	@param {String} serviceName			The service to invoke (eg: sports)
 *	@param {Object} [params]			Parameters to pass to the service handler (can be nested)
 *	@param {Object} [options]
 *	@param {String} [options.origin]	The "sender origin" to pass (eg: "http://aperture.synacor.net"). Defaults to `location.origin`.
 *	@param {Object} [options.client]	Client name (eg: "aperture")
 *	@param {Object} [options.site]		Site name (eg: "aperture-gen4")
 *	@example
 *		service('sports', {
 *			sport: 'baseball',
 *			league: 'mlb',
 *			what: 'scores',
 *			queryString: {
 *				date: '2016-09-20'
 *			}
 *		}, {
 *			origin: 'http://start.att.net',
 *			client: 'att',
 *			site: 'att-gen4'
 *		}).then(console.log.bind(console));
 */
function service(serviceName) {
	var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	var auth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

	var query = {
		action: 'fetch',
		app_server: true,
		_is_jsonp: '1',
		service_name: serviceName,
		params: params,
		// everything is a service
		_uri: 'component://Synacor/Gen4/Configuration/Components/Service/',
		// http://start.att.net
		_root_url: options.origin || cfg(options, 'portalOrigin') || location.origin,
		// eg: att
		_client_uri: 'client://client_config/' + cfg(options, 'client') + '/',
		// eg: att-gen4
		_site_uri: 'site://site_config/' + cfg(options, 'site') + '/'
		// '_parent_uri': 'zone://Synacor/Gen4/Configuration/Pages/Zones/Footer/',
		// '_page_uri': `page://Synacor/Gen4/Configuration/Pages/Home/`,
		// '_user_id': '',
		// '_auth_token': '',
		// '_session': cookies.session,	// || 'e17910b3bc7517c2f4fd3f68524a72914e53cc07-1465487956',
	};

	if (auth && __WEBPACK_IMPORTED_MODULE_2_dlv___default()(window, 'Syn.Config.Framework.UserId')) {
		query._user_id = Syn.Config.Framework.UserId;
		query._auth_token = Syn.Config.Framework.AuthToken;

		if (__WEBPACK_IMPORTED_MODULE_2_dlv___default()(window, 'Syn.Config.Framework.Session')) {
			query._session = Syn.Config.Framework.Session;
		}
	}

	if (options.cache === false) {
		//set up a query buster so that the browser doesn't cache to disk
		query._cbuster = new Date().getTime();
	}

	var queryString = Object(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* serializeQueryString */])(query);

	var appServer = cfg(options, 'portalAppServer').replace(/https?:\/\//, '');

	return Object(__WEBPACK_IMPORTED_MODULE_1__fetch_jsonp__["a" /* default */])('//' + appServer + '/_/?' + queryString, {
		callbackId: Object(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* hash */])(queryString),
		cache: options.cache,
		dedupe: options.dedupe,
		timeout: options.timeout
	}).then(transformResponse);
}

/***/ }),

/***/ 414:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hash;
/* harmony export (immutable) */ __webpack_exports__["b"] = serializeQueryString;
/* unused harmony export parseQueryString */
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/** Get a somewhat unique hash for the given Object by serializing it to JSON and hashing that string using Java's String.hash algorithm. */
function hash(str) {
	var hash = 0,
	    i = 0;
	for (; i < str.length; i++) {
		hash = (hash << 5) - hash + str.charCodeAt(i);
		hash &= hash;
	}
	return hash.toString(36).replace('-', '_');
}

/** Serialize an object into a querystring.
 *	Nested objects are serialized using PHP-style key notation (`foo[bar][baz]=1`).
 *	@param {Object} obj		Optionally-nested object to serialize.
 *	@returns {String} a=1&b=2&c[d]=3
 */
function serializeQueryString(obj) {
	var parts = [];
	obj = flatten(obj);
	for (var i in obj) {
		if (obj.hasOwnProperty(i)) {
			//eslint-disable-next-line eqeqeq
			parts.push(encodeURIComponent(i) + '=' + encodeURIComponent(obj[i] != null ? obj[i] : ''));
		}
	}return parts.sort().join('&');
}

/** Parse a Stringified querystring into an Object.
 *	Note: does not support the key-nesting of its counterpart, serializeQueryString.
 *	@param {String} str		The string to parse as a querystring
 */
function parseQueryString(str) {
	var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '&';
	var assignment = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '=';

	var values = str.split(separator),
	    obj = {};
	for (var i = 0; i < values.length; i++) {
		var parts = values[i].split(assignment);
		obj[trim(decodeURIComponent(parts[0]))] = trim(decodeURIComponent(parts.slice(1).join('=')));
	}
	return obj;
}

/** Trim leading/trailing whitespace from a string (ponyfill for String.prototype.trim)*/
var trim = function trim(str) {
	return str.replace(/(^\s+|\s+$)/g, '');
};

/** Flatten an object, converting nested keys using PHP querystring style notation.
 *	@param {Object} obj		The nested object to flatten
 */
function flatten(obj, out, prefix) {
	var count = 0;
	out = out || {};

	for (var i in obj) {
		if (obj.hasOwnProperty(i)) {
			var key = prefix ? prefix + '[' + i + ']' : i,
			    value = obj[i];

			count++;

			if (value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
				flatten(value, out, key);
			} else {
				out[key] = value;
			}
		}
	}if (!count && prefix) {
		out[prefix] = '';
	}

	return out;
}

/***/ }),

/***/ 415:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchJsonp;
var counter = 0;

var IDS = {};

var CACHE = {};

/** Basically fetch(), but JSONp.
 *	Note: for simplicity, this skips the `Response` interface entirely, returning instead the result data.
 *	@param {String} url
 *	@param {Object} [options]
 *	@param {Number} [options.timeout=30]					Seconds after which to terminate the request and reject the promise
 *	@param {Number} [options.callbackName=servicejsonp\d]	Manually specify the callback name
 *	@param {Number} [options.callbackParam=callback]		Change the callback querystring parameter
 */
function fetchJsonp(url) {
	var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	if (options.cache !== false && options.dedupe !== false && CACHE.hasOwnProperty(url)) return CACHE[url];

	return CACHE[url] = new Promise(function (resolve, reject) {
		var callback = options.callbackName || 'servicejsonp' + (options.callbackId || ++counter),
		    callbackRootName = callback,
		    c = 0;
		// ensure in-flight callback name uniqueness using an increment suffix
		while (IDS.hasOwnProperty(callback)) {
			callback = callbackRootName + '_' + ++c;
		}IDS[callback] = true;
		var done = window[callback] = function (data) {
			if (!script) return;
			delete IDS[callback];
			delete CACHE[url];
			clearTimeout(timer);
			window[callback] = null;
			try {
				delete window[callback];
			} catch (e) {}
			script.parentNode.removeChild(script);
			script = null;
			(data instanceof Error ? reject : resolve)(data);
		};
		var timer = setTimeout(function () {
			return done(Error('Timed out'));
		}, (options.timeout || 30) * 1000);
		var script = document.createElement('script');
		script.async = true;
		script.src = url + (~url.indexOf('?') ? '&' : '?') + (options.callbackParam || 'callback') + '=' + callback;
		(document.head || document.body).appendChild(script);
	});
}

/***/ }),

/***/ 416:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAME; });
/* harmony export (immutable) */ __webpack_exports__["b"] = isAllowed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cube_authn__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cube_authn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__cube_authn__);
/**
 * This is a local restriction adapter that resolves true or false
 * depending on whether or not the user is considered logged in
 * according to @cube/authn
 *
 * The restriction can be defined like so
 * authn
 *
 */


var NAME = '^authn$';

function isAllowed() {
  var session = Object(__WEBPACK_IMPORTED_MODULE_0__cube_authn__["getSessionSync"])();
  return session ? session.loggedIn === true : false;
}

/***/ }),

/***/ 417:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAME; });
/* harmony export (immutable) */ __webpack_exports__["b"] = isAllowed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cube_authn__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cube_authn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__cube_authn__);
/**
 * This is a local restriction adapter that resolves true or false
 * depending on whether or not the user is considered logged out
 * according to @cube/authn
 *
 * The restriction can be defined like so
 * notauthn
 *
 */


var NAME = '^notauthn$';

function isAllowed() {
  var session = Object(__WEBPACK_IMPORTED_MODULE_0__cube_authn__["getSessionSync"])();
  return session ? !session.loggedIn : true;
}

/***/ }),

/***/ 455:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slider = _interopRequireDefault(__webpack_require__(486));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _slider.default;
exports.default = _default;

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(75));

var _innerSlider = __webpack_require__(487);

var _json2mq = _interopRequireDefault(__webpack_require__(494));

var _defaultProps = _interopRequireDefault(__webpack_require__(496));

var _innerSliderUtils = __webpack_require__(360);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(497);

var Slider =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Slider, _React$Component);

  function Slider(props) {
    var _this;

    _classCallCheck(this, Slider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Slider).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "innerSliderRefHandler", function (ref) {
      return _this.innerSlider = ref;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickPrev", function () {
      return _this.innerSlider.slickPrev();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickNext", function () {
      return _this.innerSlider.slickNext();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _this.innerSlider.slickGoTo(slide, dontAnimate);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickPause", function () {
      return _this.innerSlider.pause("paused");
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickPlay", function () {
      return _this.innerSlider.autoPlay("play");
    });

    _this.state = {
      breakpoint: null
    };
    _this._responsiveMediaHandlers = [];
    return _this;
  }

  _createClass(Slider, [{
    key: "media",
    value: function media(query, handler) {
      // javascript handler for  css media query
      enquire.register(query, handler);

      this._responsiveMediaHandlers.push({
        query: query,
        handler: handler
      });
    } // handles responsive breakpoints

  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this2 = this;

      // performance monitoring
      //if (process.env.NODE_ENV !== 'production') {
      //const { whyDidYouUpdate } = require('why-did-you-update')
      //whyDidYouUpdate(React)
      //}
      if (this.props.responsive) {
        var breakpoints = this.props.responsive.map(function (breakpt) {
          return breakpt.breakpoint;
        }); // sort them in increasing order of their numerical value

        breakpoints.sort(function (x, y) {
          return x - y;
        });
        breakpoints.forEach(function (breakpoint, index) {
          // media query for each breakpoint
          var bQuery;

          if (index === 0) {
            bQuery = (0, _json2mq.default)({
              minWidth: 0,
              maxWidth: breakpoint
            });
          } else {
            bQuery = (0, _json2mq.default)({
              minWidth: breakpoints[index - 1] + 1,
              maxWidth: breakpoint
            });
          } // when not using server side rendering


          (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
            _this2.setState({
              breakpoint: breakpoint
            });
          });
        }); // Register media query for full screen. Need to support resize from small to large
        // convert javascript object to media query string

        var query = (0, _json2mq.default)({
          minWidth: breakpoints.slice(-1)[0]
        });
        (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
          _this2.setState({
            breakpoint: null
          });
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._responsiveMediaHandlers.forEach(function (obj) {
        enquire.unregister(obj.query, obj.handler);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var settings;
      var newProps;

      if (this.state.breakpoint) {
        newProps = this.props.responsive.filter(function (resp) {
          return resp.breakpoint === _this3.state.breakpoint;
        });
        settings = newProps[0].settings === "unslick" ? "unslick" : _objectSpread({}, _defaultProps.default, this.props, newProps[0].settings);
      } else {
        settings = _objectSpread({}, _defaultProps.default, this.props);
      } // force scrolling by one if centerMode is on


      if (settings.centerMode) {
        if (settings.slidesToScroll > 1 && "production" !== "production") {
          console.warn("slidesToScroll should be equal to 1 in centerMode, you are using ".concat(settings.slidesToScroll));
        }

        settings.slidesToScroll = 1;
      } // force showing one slide and scrolling by one if the fade mode is on


      if (settings.fade) {
        if (settings.slidesToShow > 1 && "production" !== "production") {
          console.warn("slidesToShow should be equal to 1 when fade is true, you're using ".concat(settings.slidesToShow));
        }

        if (settings.slidesToScroll > 1 && "production" !== "production") {
          console.warn("slidesToScroll should be equal to 1 when fade is true, you're using ".concat(settings.slidesToScroll));
        }

        settings.slidesToShow = 1;
        settings.slidesToScroll = 1;
      } // makes sure that children is an array, even when there is only 1 child


      var children = _react.default.Children.toArray(this.props.children); // Children may contain false or null, so we should filter them
      // children may also contain string filled with spaces (in certain cases where we use jsx strings)


      children = children.filter(function (child) {
        if (typeof child === "string") {
          return !!child.trim();
        }

        return !!child;
      }); // rows and slidesPerRow logic is handled here

      if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
        console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
        settings.variableWidth = false;
      }

      var newChildren = [];
      var currentWidth = null;

      for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
        var newSlide = [];

        for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
          var row = [];

          for (var k = j; k < j + settings.slidesPerRow; k += 1) {
            if (settings.variableWidth && children[k].props.style) {
              currentWidth = children[k].props.style.width;
            }

            if (k >= children.length) break;
            row.push(_react.default.cloneElement(children[k], {
              key: 100 * i + 10 * j + k,
              tabIndex: -1,
              style: {
                width: "".concat(100 / settings.slidesPerRow, "%"),
                display: "inline-block"
              }
            }));
          }

          newSlide.push(_react.default.createElement("div", {
            key: 10 * i + j
          }, row));
        }

        if (settings.variableWidth) {
          newChildren.push(_react.default.createElement("div", {
            key: i,
            style: {
              width: currentWidth
            }
          }, newSlide));
        } else {
          newChildren.push(_react.default.createElement("div", {
            key: i
          }, newSlide));
        }
      }

      if (settings === "unslick") {
        var className = "regular slider " + (this.props.className || "");
        return _react.default.createElement("div", {
          className: className
        }, newChildren);
      } else if (newChildren.length <= settings.slidesToShow) {
        settings.unslick = true;
      }

      return _react.default.createElement(_innerSlider.InnerSlider, _extends({
        ref: this.innerSliderRefHandler
      }, settings), newChildren);
    }
  }]);

  return Slider;
}(_react.default.Component);

exports.default = Slider;

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InnerSlider = void 0;

var _react = _interopRequireDefault(__webpack_require__(75));

var _reactDom = _interopRequireDefault(__webpack_require__(75));

var _initialState = _interopRequireDefault(__webpack_require__(488));

var _lodash = _interopRequireDefault(__webpack_require__(489));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _innerSliderUtils = __webpack_require__(360);

var _track = __webpack_require__(490);

var _dots = __webpack_require__(491);

var _arrows = __webpack_require__(492);

var _resizeObserverPolyfill = _interopRequireDefault(__webpack_require__(493));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var InnerSlider =
/*#__PURE__*/
function (_React$Component) {
  _inherits(InnerSlider, _React$Component);

  function InnerSlider(props) {
    var _this;

    _classCallCheck(this, InnerSlider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InnerSlider).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "listRefHandler", function (ref) {
      return _this.list = ref;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "trackRefHandler", function (ref) {
      return _this.track = ref;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "adaptHeight", function () {
      if (_this.props.adaptiveHeight && _this.list) {
        var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));

        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentWillMount", function () {
      _this.ssrInit();

      _this.props.onInit && _this.props.onInit();

      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread({}, _this.props, _this.state));

        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });

          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentDidMount", function () {
      var spec = _objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props);

      _this.updateState(spec, true, function () {
        _this.adaptHeight();

        _this.props.autoplay && _this.autoPlay("update");
      });

      if (_this.props.lazyLoad === "progressive") {
        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
      }

      _this.ro = new _resizeObserverPolyfill.default(function () {
        if (_this.state.animating) {
          _this.onWindowResized(false); // don't set trackStyle hence don't break animation


          _this.callbackTimers.push(setTimeout(function () {
            return _this.onWindowResized();
          }, _this.props.speed));
        } else {
          _this.onWindowResized();
        }
      });

      _this.ro.observe(_this.list);

      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
      }); // To support server-side rendering

      if (!window) {
        return;
      }

      if (window.addEventListener) {
        window.addEventListener("resize", _this.onWindowResized);
      } else {
        window.attachEvent("onresize", _this.onWindowResized);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentWillUnmount", function () {
      if (_this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
      }

      if (_this.lazyLoadTimer) {
        clearInterval(_this.lazyLoadTimer);
      }

      if (_this.callbackTimers.length) {
        _this.callbackTimers.forEach(function (timer) {
          return clearTimeout(timer);
        });

        _this.callbackTimers = [];
      }

      if (window.addEventListener) {
        window.removeEventListener("resize", _this.onWindowResized);
      } else {
        window.detachEvent("onresize", _this.onWindowResized);
      }

      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentWillReceiveProps", function (nextProps) {
      var spec = _objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, nextProps, _this.state);

      var setTrackStyle = false;

      var _arr = Object.keys(_this.props);

      for (var _i = 0; _i < _arr.length; _i++) {
        var key = _arr[_i];

        if (!nextProps.hasOwnProperty(key)) {
          setTrackStyle = true;
          break;
        }

        if (_typeof(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
          continue;
        }

        if (nextProps[key] !== _this.props[key]) {
          setTrackStyle = true;
          break;
        }
      }

      _this.updateState(spec, setTrackStyle, function () {
        if (_this.state.currentSlide >= _react.default.Children.count(nextProps.children)) {
          _this.changeSlide({
            message: "index",
            index: _react.default.Children.count(nextProps.children) - nextProps.slidesToShow,
            currentSlide: _this.state.currentSlide
          });
        }

        if (nextProps.autoplay) {
          _this.autoPlay("update");
        } else {
          _this.pause("paused");
        }
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentDidUpdate", function () {
      _this.checkImagesLoad();

      _this.props.onReInit && _this.props.onReInit();

      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread({}, _this.props, _this.state));

        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });

          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      } // if (this.props.onLazyLoad) {
      //   this.props.onLazyLoad([leftMostSlide])
      // }


      _this.adaptHeight();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onWindowResized", function (setTrackStyle) {
      if (_this.debouncedResize) _this.debouncedResize.cancel();
      _this.debouncedResize = (0, _lodash.default)(function () {
        return _this.resizeWindow(setTrackStyle);
      }, 50);

      _this.debouncedResize();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "resizeWindow", function () {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (!_reactDom.default.findDOMNode(_this.track)) return;

      var spec = _objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props, _this.state);

      _this.updateState(spec, setTrackStyle, function () {
        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
      }); // animating state should be cleared while resizing, otherwise autoplay stops working


      _this.setState({
        animating: false
      });

      clearTimeout(_this.animationEndCallback);
      delete _this.animationEndCallback;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "updateState", function (spec, setTrackStyle, callback) {
      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
      spec = _objectSpread({}, spec, updatedState, {
        slideIndex: updatedState.currentSlide
      });
      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
      spec = _objectSpread({}, spec, {
        left: targetLeft
      });
      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);

      if (setTrackStyle || _react.default.Children.count(_this.props.children) !== _react.default.Children.count(spec.children)) {
        updatedState["trackStyle"] = trackStyle;
      }

      _this.setState(updatedState, callback);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "ssrInit", function () {
      if (_this.props.variableWidth) {
        var _trackWidth = 0,
            _trackLeft = 0;
        var childrenWidths = [];
        var preClones = (0, _innerSliderUtils.getPreClones)(_objectSpread({}, _this.props, _this.state, {
          slideCount: _this.props.children.length
        }));
        var postClones = (0, _innerSliderUtils.getPostClones)(_objectSpread({}, _this.props, _this.state, {
          slideCount: _this.props.children.length
        }));

        _this.props.children.forEach(function (child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });

        for (var i = 0; i < preClones; i++) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
        }

        for (var _i2 = 0; _i2 < postClones; _i2++) {
          _trackWidth += childrenWidths[_i2];
        }

        for (var _i3 = 0; _i3 < _this.state.currentSlide; _i3++) {
          _trackLeft += childrenWidths[_i3];
        }

        var _trackStyle = {
          width: _trackWidth + "px",
          left: -_trackLeft + "px"
        };

        if (_this.props.centerMode) {
          var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
          _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
        }

        _this.setState({
          trackStyle: _trackStyle
        });

        return;
      }

      var childrenCount = _react.default.Children.count(_this.props.children);

      var spec = _objectSpread({}, _this.props, _this.state, {
        slideCount: childrenCount
      });

      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;

      if (_this.props.centerMode) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }

      var trackStyle = {
        width: trackWidth + "%",
        left: trackLeft + "%"
      };

      _this.setState({
        slideWidth: slideWidth + "%",
        trackStyle: trackStyle
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "checkImagesLoad", function () {
      var images = document.querySelectorAll(".slick-slide img");
      var imagesCount = images.length,
          loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
        };

        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;

          image.onclick = function () {
            prevClickHandler();
            image.parentNode.focus();
          };
        }

        if (!image.onload) {
          if (_this.props.lazyLoad) {
            image.onload = function () {
              _this.adaptHeight();

              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
            };
          } else {
            image.onload = handler;

            image.onerror = function () {
              handler();
              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
            };
          }
        }
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "progressiveLazyLoad", function () {
      var slidesToLoad = [];

      var spec = _objectSpread({}, _this.props, _this.state);

      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }

      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }

      if (slidesToLoad.length > 0) {
        _this.setState(function (state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });

        if (_this.props.onLazyLoad) {
          _this.props.onLazyLoad(slidesToLoad);
        }
      } else {
        if (_this.lazyLoadTimer) {
          clearInterval(_this.lazyLoadTimer);
          delete _this.lazyLoadTimer;
        }
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slideHandler", function (index) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
          asNavFor = _this$props.asNavFor,
          beforeChange = _this$props.beforeChange,
          onLazyLoad = _this$props.onLazyLoad,
          speed = _this$props.speed,
          afterChange = _this$props.afterChange; // capture currentslide before state is updated

      var currentSlide = _this.state.currentSlide;

      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_objectSpread({
        index: index
      }, _this.props, _this.state, {
        trackRef: _this.track,
        useCSS: _this.props.useCSS && !dontAnimate
      })),
          state = _slideHandler.state,
          nextState = _slideHandler.nextState;

      if (!state) return;
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);

      _this.setState(state, function () {
        asNavFor && asNavFor.innerSlider.state.currentSlide !== currentSlide && asNavFor.innerSlider.slideHandler(index);
        if (!nextState) return;
        _this.animationEndCallback = setTimeout(function () {
          var animating = nextState.animating,
              firstBatch = _objectWithoutProperties(nextState, ["animating"]);

          _this.setState(firstBatch, function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.setState({
                animating: animating
              });
            }, 10));

            afterChange && afterChange(state.currentSlide);
            delete _this.animationEndCallback;
          });
        }, speed);
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "changeSlide", function (options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var spec = _objectSpread({}, _this.props, _this.state);

      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
      if (targetSlide !== 0 && !targetSlide) return;

      if (dontAnimate === true) {
        _this.slideHandler(targetSlide, dontAnimate);
      } else {
        _this.slideHandler(targetSlide);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "clickHandler", function (e) {
      if (_this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }

      _this.clickable = true;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "keyHandler", function (e) {
      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
      dir !== "" && _this.changeSlide({
        message: dir
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selectHandler", function (options) {
      _this.changeSlide(options);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "disableBodyScroll", function () {
      var preventDefault = function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      };

      window.ontouchmove = preventDefault;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "enableBodyScroll", function () {
      window.ontouchmove = null;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "swipeStart", function (e) {
      if (_this.props.verticalSwiping) {
        _this.disableBodyScroll();
      }

      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
      state !== "" && _this.setState(state);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "swipeMove", function (e) {
      var state = (0, _innerSliderUtils.swipeMove)(e, _objectSpread({}, _this.props, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;

      if (state["swiping"]) {
        _this.clickable = false;
      }

      _this.setState(state);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "swipeEnd", function (e) {
      var state = (0, _innerSliderUtils.swipeEnd)(e, _objectSpread({}, _this.props, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      var triggerSlideHandler = state["triggerSlideHandler"];
      delete state["triggerSlideHandler"];

      _this.setState(state);

      if (triggerSlideHandler === undefined) return;

      _this.slideHandler(triggerSlideHandler);

      if (_this.props.verticalSwiping) {
        _this.enableBodyScroll();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickPrev", function () {
      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "previous"
        });
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickNext", function () {
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "next"
        });
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      slide = Number(slide);
      if (isNaN(slide)) return "";

      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "index",
          index: slide,
          currentSlide: _this.state.currentSlide
        }, dontAnimate);
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "play", function () {
      var nextIndex;

      if (_this.props.rtl) {
        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
      } else {
        if ((0, _innerSliderUtils.canGoNext)(_objectSpread({}, _this.props, _this.state))) {
          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
        } else {
          return false;
        }
      }

      _this.slideHandler(nextIndex);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "autoPlay", function (playType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }

      var autoplaying = _this.state.autoplaying;

      if (playType === "update") {
        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
          return;
        }
      } else if (playType === "leave") {
        if (autoplaying === "paused" || autoplaying === "focused") {
          return;
        }
      } else if (playType === "blur") {
        if (autoplaying === "paused" || autoplaying === "hovered") {
          return;
        }
      }

      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);

      _this.setState({
        autoplaying: "playing"
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "pause", function (pauseType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
        _this.autoplayTimer = null;
      }

      var autoplaying = _this.state.autoplaying;

      if (pauseType === "paused") {
        _this.setState({
          autoplaying: "paused"
        });
      } else if (pauseType === "focused") {
        if (autoplaying === "hovered" || autoplaying === "playing") {
          _this.setState({
            autoplaying: "focused"
          });
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === "playing") {
          _this.setState({
            autoplaying: "hovered"
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onDotsOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onDotsLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTrackOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTrackLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onSlideFocus", function () {
      return _this.props.autoplay && _this.pause("focused");
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onSlideBlur", function () {
      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "render", function () {
      var className = (0, _classnames.default)("slick-slider", _this.props.className, {
        "slick-vertical": _this.props.vertical,
        "slick-initialized": true
      });

      var spec = _objectSpread({}, _this.props, _this.state);

      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
      var pauseOnHover = _this.props.pauseOnHover;
      trackProps = _objectSpread({}, trackProps, {
        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
        focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
      });
      var dots;

      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
        dotProps = _objectSpread({}, dotProps, {
          clickHandler: _this.changeSlide,
          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
        });
        dots = _react.default.createElement(_dots.Dots, dotProps);
      }

      var prevArrow, nextArrow;
      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      arrowProps.clickHandler = _this.changeSlide;

      if (_this.props.arrows) {
        prevArrow = _react.default.createElement(_arrows.PrevArrow, arrowProps);
        nextArrow = _react.default.createElement(_arrows.NextArrow, arrowProps);
      }

      var verticalHeightStyle = null;

      if (_this.props.vertical) {
        verticalHeightStyle = {
          height: _this.state.listHeight
        };
      }

      var centerPaddingStyle = null;

      if (_this.props.vertical === false) {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: "0px " + _this.props.centerPadding
          };
        }
      } else {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: _this.props.centerPadding + " 0px"
          };
        }
      }

      var listStyle = _objectSpread({}, verticalHeightStyle, centerPaddingStyle);

      var touchMove = _this.props.touchMove;
      var listProps = {
        className: "slick-list",
        style: listStyle,
        onClick: _this.clickHandler,
        onMouseDown: touchMove ? _this.swipeStart : null,
        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onMouseUp: touchMove ? _this.swipeEnd : null,
        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onTouchStart: touchMove ? _this.swipeStart : null,
        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onTouchEnd: touchMove ? _this.swipeEnd : null,
        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
      };
      var innerSliderProps = {
        className: className,
        dir: "ltr"
      };

      if (_this.props.unslick) {
        listProps = {
          className: "slick-list"
        };
        innerSliderProps = {
          className: className
        };
      }

      return _react.default.createElement("div", innerSliderProps, _react.default.createElement("div", _extends({
        ref: _this.listRefHandler
      }, listProps), _react.default.createElement(_track.Track, _extends({
        ref: _this.trackRefHandler
      }, trackProps), _this.props.children)), !_this.props.unslick ? prevArrow : "", !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
    });

    _this.list = null;
    _this.track = null;
    _this.state = _objectSpread({}, _initialState.default, {
      currentSlide: _this.props.initialSlide,
      slideCount: _react.default.Children.count(_this.props.children)
    });
    _this.callbackTimers = [];
    _this.clickable = true;
    _this.debouncedResize = null;
    return _this;
  }

  return InnerSlider;
}(_react.default.Component);

exports.InnerSlider = InnerSlider;

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var initialState = {
  animating: false,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: false,
  edgeDragged: false,
  initialized: false,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: false,
  slideCount: null,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: false,
  // used by swipeEvent. differentites between touch and swipe.
  swiping: false,
  touchObject: {
    startX: 0,
    startY: 0,
    curX: 0,
    curY: 0
  },
  trackStyle: {},
  trackWidth: 0
};
var _default = initialState;
exports.default = _default;

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Track = void 0;

var _react = _interopRequireDefault(__webpack_require__(75));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _innerSliderUtils = __webpack_require__(360);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }

  slickCloned = index < 0 || index >= spec.slideCount;

  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;

    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }

  var slickCurrent = index === spec.currentSlide;
  return {
    "slick-slide": true,
    "slick-active": slickActive,
    "slick-center": slickCenter,
    "slick-cloned": slickCloned,
    "slick-current": slickCurrent // dubious in case of RTL

  };
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }

  if (spec.fade) {
    style.position = "relative";

    if (spec.vertical) {
      style.top = -spec.index * parseInt(spec.slideHeight);
    } else {
      style.left = -spec.index * parseInt(spec.slideWidth);
    }

    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
    style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    style.WebkitTransition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  return child.key || fallbackKey;
};

var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];

  var childrenCount = _react.default.Children.count(spec.children);

  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);

  _react.default.Children.forEach(spec.children, function (elem, index) {
    var child;
    var childOnClickOptions = {
      message: "children",
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    }; // in case of lazyLoad, whether or not we want to fetch the slide

    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
      child = elem;
    } else {
      child = _react.default.createElement("div", null);
    }

    var childStyle = getSlideStyle(_objectSpread({}, spec, {
      index: index
    }));
    var slideClass = child.props.className || "";
    var slideClasses = getSlideClasses(_objectSpread({}, spec, {
      index: index
    })); // push a cloned element of the desired slide

    slides.push(_react.default.cloneElement(child, {
      key: "original" + getKey(child, index),
      "data-index": index,
      className: (0, _classnames.default)(slideClasses, slideClass),
      tabIndex: "-1",
      "aria-hidden": !slideClasses["slick-active"],
      style: _objectSpread({
        outline: "none"
      }, child.props.style || {}, childStyle),
      onClick: function onClick(e) {
        child.props && child.props.onClick && child.props.onClick(e);

        if (spec.focusOnSelect) {
          spec.focusOnSelect(childOnClickOptions);
        }
      }
    })); // if slide needs to be precloned or postcloned

    if (spec.infinite && spec.fade === false) {
      var preCloneNo = childrenCount - index;

      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
        key = -preCloneNo;

        if (key >= startIndex) {
          child = elem;
        }

        slideClasses = getSlideClasses(_objectSpread({}, spec, {
          index: key
        }));
        preCloneSlides.push(_react.default.cloneElement(child, {
          key: "precloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames.default)(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _objectSpread({}, child.props.style || {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);

            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }

      if (childrenCount !== spec.slidesToShow) {
        key = childrenCount + index;

        if (key < endIndex) {
          child = elem;
        }

        slideClasses = getSlideClasses(_objectSpread({}, spec, {
          index: key
        }));
        postCloneSlides.push(_react.default.cloneElement(child, {
          key: "postcloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames.default)(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _objectSpread({}, child.props.style || {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);

            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }
    }
  });

  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};

var Track =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Track, _React$PureComponent);

  function Track() {
    _classCallCheck(this, Track);

    return _possibleConstructorReturn(this, _getPrototypeOf(Track).apply(this, arguments));
  }

  _createClass(Track, [{
    key: "render",
    value: function render() {
      var slides = renderSlides(this.props);
      var _this$props = this.props,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseOver = _this$props.onMouseOver,
          onMouseLeave = _this$props.onMouseLeave;
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      return _react.default.createElement("div", _extends({
        className: "slick-track",
        style: this.props.trackStyle
      }, mouseEvents), slides);
    }
  }]);

  return Track;
}(_react.default.PureComponent);

exports.Track = Track;

/***/ }),

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dots = void 0;

var _react = _interopRequireDefault(__webpack_require__(75));

var _classnames = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var getDotCount = function getDotCount(spec) {
  var dots;

  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  }

  return dots;
};

var Dots =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Dots, _React$PureComponent);

  function Dots() {
    _classCallCheck(this, Dots);

    return _possibleConstructorReturn(this, _getPrototypeOf(Dots).apply(this, arguments));
  }

  _createClass(Dots, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      // In Autoplay the focus stays on clicked button even after transition
      // to next slide. That only goes away by click somewhere outside
      e.preventDefault();
      this.props.clickHandler(options);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var dotCount = getDotCount({
        slideCount: this.props.slideCount,
        slidesToScroll: this.props.slidesToScroll,
        slidesToShow: this.props.slidesToShow,
        infinite: this.props.infinite
      }); // Apply join & split to Array to pre-fill it for IE8
      //
      // Credit: http://stackoverflow.com/a/13735425/1849458

      var _this$props = this.props,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseOver = _this$props.onMouseOver,
          onMouseLeave = _this$props.onMouseLeave;
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      var dots = Array.apply(null, Array(dotCount + 1).join("0").split("")).map(function (x, i) {
        var leftBound = i * _this.props.slidesToScroll;
        var rightBound = i * _this.props.slidesToScroll + (_this.props.slidesToScroll - 1);
        var className = (0, _classnames.default)({
          "slick-active": _this.props.currentSlide >= leftBound && _this.props.currentSlide <= rightBound
        });
        var dotOptions = {
          message: "dots",
          index: i,
          slidesToScroll: _this.props.slidesToScroll,
          currentSlide: _this.props.currentSlide
        };

        var onClick = _this.clickHandler.bind(_this, dotOptions);

        return _react.default.createElement("li", {
          key: i,
          className: className
        }, _react.default.cloneElement(_this.props.customPaging(i), {
          onClick: onClick
        }));
      });
      return _react.default.cloneElement(this.props.appendDots(dots), _objectSpread({
        className: this.props.dotsClass
      }, mouseEvents));
    }
  }]);

  return Dots;
}(_react.default.PureComponent);

exports.Dots = Dots;

/***/ }),

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NextArrow = exports.PrevArrow = void 0;

var _react = _interopRequireDefault(__webpack_require__(75));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _innerSliderUtils = __webpack_require__(360);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var PrevArrow =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(PrevArrow, _React$PureComponent);

  function PrevArrow() {
    _classCallCheck(this, PrevArrow);

    return _possibleConstructorReturn(this, _getPrototypeOf(PrevArrow).apply(this, arguments));
  }

  _createClass(PrevArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }

      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var prevClasses = {
        "slick-arrow": true,
        "slick-prev": true
      };
      var prevHandler = this.clickHandler.bind(this, {
        message: "previous"
      });

      if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
        prevClasses["slick-disabled"] = true;
        prevHandler = null;
      }

      var prevArrowProps = {
        key: "0",
        "data-role": "none",
        className: (0, _classnames.default)(prevClasses),
        style: {
          display: "block"
        },
        onClick: prevHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var prevArrow;

      if (this.props.prevArrow) {
        prevArrow = _react.default.cloneElement(this.props.prevArrow, _objectSpread({}, prevArrowProps, customProps));
      } else {
        prevArrow = _react.default.createElement("button", _extends({
          key: "0",
          type: "button"
        }, prevArrowProps), " ", "Previous");
      }

      return prevArrow;
    }
  }]);

  return PrevArrow;
}(_react.default.PureComponent);

exports.PrevArrow = PrevArrow;

var NextArrow =
/*#__PURE__*/
function (_React$PureComponent2) {
  _inherits(NextArrow, _React$PureComponent2);

  function NextArrow() {
    _classCallCheck(this, NextArrow);

    return _possibleConstructorReturn(this, _getPrototypeOf(NextArrow).apply(this, arguments));
  }

  _createClass(NextArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }

      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var nextClasses = {
        "slick-arrow": true,
        "slick-next": true
      };
      var nextHandler = this.clickHandler.bind(this, {
        message: "next"
      });

      if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
        nextClasses["slick-disabled"] = true;
        nextHandler = null;
      }

      var nextArrowProps = {
        key: "1",
        "data-role": "none",
        className: (0, _classnames.default)(nextClasses),
        style: {
          display: "block"
        },
        onClick: nextHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var nextArrow;

      if (this.props.nextArrow) {
        nextArrow = _react.default.cloneElement(this.props.nextArrow, _objectSpread({}, nextArrowProps, customProps));
      } else {
        nextArrow = _react.default.createElement("button", _extends({
          key: "1",
          type: "button"
        }, nextArrowProps), " ", "Next");
      }

      return nextArrow;
    }
  }]);

  return NextArrow;
}(_react.default.PureComponent);

exports.NextArrow = NextArrow;

/***/ }),

/***/ 493:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return (/** @class */function () {
            function class_1() {
                this.__entries__ = [];
            }
            Object.defineProperty(class_1.prototype, "size", {
                /**
                 * @returns {boolean}
                 */
                get: function get() {
                    return this.__entries__.length;
                },
                enumerable: true,
                configurable: true
            });
            /**
             * @param {*} key
             * @returns {*}
             */
            class_1.prototype.get = function (key) {
                var index = getIndex(this.__entries__, key);
                var entry = this.__entries__[index];
                return entry && entry[1];
            };
            /**
             * @param {*} key
             * @param {*} value
             * @returns {void}
             */
            class_1.prototype.set = function (key, value) {
                var index = getIndex(this.__entries__, key);
                if (~index) {
                    this.__entries__[index][1] = value;
                } else {
                    this.__entries__.push([key, value]);
                }
            };
            /**
             * @param {*} key
             * @returns {void}
             */
            class_1.prototype.delete = function (key) {
                var entries = this.__entries__;
                var index = getIndex(entries, key);
                if (~index) {
                    entries.splice(index, 1);
                }
            };
            /**
             * @param {*} key
             * @returns {void}
             */
            class_1.prototype.has = function (key) {
                return !!~getIndex(this.__entries__, key);
            };
            /**
             * @returns {void}
             */
            class_1.prototype.clear = function () {
                this.__entries__.splice(0);
            };
            /**
             * @param {Function} callback
             * @param {*} [ctx=null]
             * @returns {void}
             */
            class_1.prototype.forEach = function (callback, ctx) {
                if (ctx === void 0) {
                    ctx = null;
                }
                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                    var entry = _a[_i];
                    callback.call(ctx, entry[1], entry[0]);
                }
            };
            return class_1;
        }()
    );
}();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
}();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) {
        return setTimeout(function () {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle(callback, delay) {
    var leadingCall = false,
        trailingCall = false,
        lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName,
            propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = function defineConfigurable(target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = function getWindowOf(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
};

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth,
        clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width),
        height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) {
            return target instanceof getWindowOf(target).SVGGraphicsElement;
        };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) {
        return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x,
        y = _a.y,
        width = _a.width,
        height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();

var ResizeObserverEntry = /** @class */function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}();

var ResizeObserverSPI = /** @class */function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
['observe', 'unobserve', 'disconnect'].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
}();

/* harmony default export */ __webpack_exports__["default"] = (index);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(19)))

/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

var camel2hyphen = __webpack_require__(495);

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and '
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', '
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

/***/ }),

/***/ 495:
/***/ (function(module, exports) {

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(75));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultProps = {
  accessibility: true,
  adaptiveHeight: false,
  afterChange: null,
  appendDots: function appendDots(dots) {
    return _react.default.createElement("ul", {
      style: {
        display: "block"
      }
    }, dots);
  },
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  beforeChange: null,
  centerMode: false,
  centerPadding: "50px",
  className: "",
  cssEase: "ease",
  customPaging: function customPaging(i) {
    return _react.default.createElement("button", null, i + 1);
  },
  dots: false,
  dotsClass: "slick-dots",
  draggable: true,
  easing: "linear",
  edgeFriction: 0.35,
  fade: false,
  focusOnSelect: false,
  infinite: true,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: true,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: false,
  slide: "div",
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: true,
  swipeEvent: null,
  swipeToSlide: false,
  touchMove: true,
  touchThreshold: 5,
  useCSS: true,
  useTransform: true,
  variableWidth: false,
  vertical: false,
  waitForAnimate: true
};
var _default = defaultProps;
exports.default = _default;

/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

var MediaQueryDispatch = __webpack_require__(498);
module.exports = new MediaQueryDispatch();


/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

var MediaQuery = __webpack_require__(499);
var Util = __webpack_require__(403);
var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction(options)) {
            options = { match : options };
        }
        if(!isArray(options)) {
            options = [options];
        }
        each(options, function(handler) {
            if (isFunction(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

module.exports = MediaQueryDispatch;


/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

var QueryHandler = __webpack_require__(500);
var each = __webpack_require__(403).each;

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

module.exports = MediaQuery;


/***/ }),

/***/ 500:
/***/ (function(module, exports) {

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

module.exports = QueryHandler;


/***/ }),

/***/ 501:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return configure; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preconf__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_default_config_json__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_default_config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_default_config_json__);
/* unused harmony reexport defaults */



var configure = Object(__WEBPACK_IMPORTED_MODULE_0_preconf__["a" /* default */])(null, __WEBPACK_IMPORTED_MODULE_1__config_default_config_json___default.a);


/***/ }),

/***/ 502:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchSlides;
/* unused harmony export filterSlides */
/* unused harmony export restrictSlides */
/* unused harmony export limitMaxSlides */
/* harmony export (immutable) */ __webpack_exports__["b"] = getImage;
/* harmony export (immutable) */ __webpack_exports__["c"] = loadBgImage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dlv__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dlv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dlv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__collection__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cube_utils_lib_scs_api__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cube_utils_lib_scs_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__cube_utils_lib_scs_api__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cube_restrictions__ = __webpack_require__(369);





function fetchSlides(feed, site, apiOrigin, maxSlideCount) {
	return Object(__WEBPACK_IMPORTED_MODULE_2__cube_utils_lib_scs_api__["fetchSCS"])('/dccs/id/' + feed + '/', site, apiOrigin).then(function (data) {
		return filterSlides(data.slides);
	}).then(function (slides) {
		return restrictSlides(slides);
	}).then(function (slides) {
		return limitMaxSlides(slides, maxSlideCount);
	});
}

// Filter slides that don't meet all of our requirements
function filterSlides(slides, maxSlideCount) {
	return slides.reduce(function (acc, slide) {
		var cardType = Object(__WEBPACK_IMPORTED_MODULE_1__collection__["b" /* getCardWidget */])(slide);
		// If no mapping then drop the slide to enforce all slide types having a canRender function
		if (!cardType || !cardType.canRender) {
			return acc;
		}

		// If we can't render then drop the slide
		if (!cardType.canRender(slide)) {
			return acc;
		}

		// No restriction so keep the slide for rendering
		acc.push(slide);
		return acc;
	}, []);
}

// Remove slides that have restrictions that do not pass
function restrictSlides(slides) {
	var allowed = [];
	for (var i = 0; i < slides.length; i++) {
		if (slides[i].restriction_uri) {
			allowed[i] = Object(__WEBPACK_IMPORTED_MODULE_3__cube_restrictions__["b" /* default */])(slides[i].restriction_uri);
		} else {
			allowed[i] = true;
		}
	}

	return Promise.all(allowed).then(function (res) {
		return slides.reduce(function (acc, slide, i) {
			if (res[i]) {
				acc.push(slide);
			}
			return acc;
		}, []);
	});
}

// Remove any slides beyond the max slide count we allow
function limitMaxSlides(slides, maxSlideCount) {
	if (slides.length > maxSlideCount) {
		return slides.slice(0, maxSlideCount);
	}

	return slides;
}

var MIN_WIDTH = 320;

function getImage(slide, cardSize) {
	var match = __WEBPACK_IMPORTED_MODULE_0_dlv___default()(slide.assets[0].images.filter(function (image) {
		return image.role === cardSize;
	}), '0');

	// found cardSize and it has ok width
	if (__WEBPACK_IMPORTED_MODULE_0_dlv___default()(match, 'width') >= MIN_WIDTH) {
		return match.src;
	}

	// if was looking for small and wasn't big enough, look for medium image
	if (cardSize.indexOf('small-') === 0) {
		var newCardSize = cardSize.replace('small-', 'medium-');
		var largeOption = __WEBPACK_IMPORTED_MODULE_0_dlv___default()(slide.assets[0].images.filter(function (image) {
			return image.role === newCardSize;
		}), '0');
		if (largeOption) return largeOption.src;
	}

	// If we have a match, use it even if it is small
	if (match) return match.src;

	// Default to returning the first image if could not get a match
	return __WEBPACK_IMPORTED_MODULE_0_dlv___default()(slide, 'assets.0.images.0.src');
}

function loadBgImage(url, onLoadEvent) {
	var img = new Image();
	img.onload = function () {
		onLoadEvent();
	};
	img.src = url;
	img = null;
}

/***/ }),

/***/ 650:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CARD_COLLECTION */
/* unused harmony export typeForCardData */
/* harmony export (immutable) */ __webpack_exports__["b"] = getCardWidget;
/* harmony export (immutable) */ __webpack_exports__["a"] = getCardType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_cards_singleAsset__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cards_promoOneImage__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_cards_taboola_organic__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_cards_taboola_sponsored__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_ad__ = __webpack_require__(780);






/**
 * Contains collections of CardWidgets
 * Use `getCardWidget()` instead of importing this directly.
 */
var CARD_COLLECTION = {
	default: __WEBPACK_IMPORTED_MODULE_0__components_cards_singleAsset__["a" /* default */],
	single_image_story: __WEBPACK_IMPORTED_MODULE_0__components_cards_singleAsset__["a" /* default */],
	promo_1_image: __WEBPACK_IMPORTED_MODULE_1__components_cards_promoOneImage__["a" /* default */],
	'Taboola-Organic': __WEBPACK_IMPORTED_MODULE_2__components_cards_taboola_organic__["a" /* default */],
	'Taboola-Sponsored': __WEBPACK_IMPORTED_MODULE_3__components_cards_taboola_sponsored__["a" /* default */],
	Ad: __WEBPACK_IMPORTED_MODULE_4__components_cards_ad__["a" /* default */]
};

/**
 * Will return the type property of the supplied cardData object, but...
 * If the type is 'framework-entity' and a uri  property is also present, the uri will be returned as the type.
 * @param {Object} cardData - An object with a type property that's a string.
 */
function typeForCardData() {
	var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	    type = _ref.type,
	    uri = _ref.uri;

	return type === 'framework-entity' && uri && uri || type;
}

/**
 * Retrieves a CardWidget for the supplied cardData/type and collection.
 * @param {Object|String} cardData - Either an object with a .type string property or a string of the type.
 * @returns {Object} A CardWidget Object or null if the CardWidget cannot be found.
 */
function getCardWidget(cardData) {
	if (!cardData) return null;
	if (typeof cardData === 'string') return CARD_COLLECTION[cardData];
	if (cardData.type) return CARD_COLLECTION[typeForCardData(cardData)];
	return null;
}

function getCardType(cardData) {
	if (!cardData) return null;
	if (typeof cardData === 'string') return cardData;
	if (cardData.type) return typeForCardData(cardData);
	return null;
}

/***/ }),

/***/ 651:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TaboolaJs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dlv__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dlv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_dlv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cube_track__ = __webpack_require__(73);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/** Creates div for taboola js insertion
 */
var TaboolaJs = function (_Component) {
	_inherits(TaboolaJs, _Component);

	function TaboolaJs() {
		var _temp, _this, _ret;

		_classCallCheck(this, TaboolaJs);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.trackClick = function (e) {
			var _trackEvent;

			Object(__WEBPACK_IMPORTED_MODULE_2__cube_track__["k" /* trackEvent */])(_this.context, (_trackEvent = {}, _trackEvent[__WEBPACK_IMPORTED_MODULE_2__cube_track__["a" /* INPUT_KEYS */].action] = 'click', _trackEvent[__WEBPACK_IMPORTED_MODULE_2__cube_track__["a" /* INPUT_KEYS */].priority] = 'high', _trackEvent[__WEBPACK_IMPORTED_MODULE_2__cube_track__["b" /* STANDARD_KEYS */].contenturl] = __WEBPACK_IMPORTED_MODULE_1_dlv___default()(e, 'srcElement.parentNode.parentNode.href'), _trackEvent[__WEBPACK_IMPORTED_MODULE_2__cube_track__["b" /* STANDARD_KEYS */].contenttext] = __WEBPACK_IMPORTED_MODULE_1_dlv___default()(e, 'srcElement.parentNode.parentNode.title'), _trackEvent[__WEBPACK_IMPORTED_MODULE_2__cube_track__["b" /* STANDARD_KEYS */].contentsource] = 'Taboola' + (__WEBPACK_IMPORTED_MODULE_1_dlv___default()(e, 'srcElement.parentNode.parentNode.target') === '_blank' ? '-Sponsored' : '-Organic'), _trackEvent));
		}, _this.shouldComponentUpdate = function () {
			return false;
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	TaboolaJs.prototype.componentDidMount = function componentDidMount() {
		if (this.props.taboolaJsParams && window._taboola) {
			window._taboola.push(_extends({
				container: this.props.id
			}, this.props.taboolaJsParams));
		}
	};

	TaboolaJs.prototype.render = function render(_ref) {
		var id = _ref.id,
		    divClass = _ref.class,
		    qeId = _ref.qeId,
		    rest = _objectWithoutProperties(_ref, ['id', 'class', 'qeId']);

		if (rest.taboolaJsParams) delete rest.taboolaJsParams;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', _extends({ onClick: this.trackClick, id: id, 'class': divClass, qid: qeId }, rest));
	};

	return TaboolaJs;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/***/ }),

/***/ 771:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Pending */
/* unused harmony export Rejected */
/* unused harmony export Arrow */
/* unused harmony export Dcc */
/* unused harmony export SlideFetchingDcc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cube_track__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__synacorforks_react_slick__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__synacorforks_react_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__synacorforks_react_slick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_preact_context_provider__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_wiretie__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_utils__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_collection__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_dlv__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_dlv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_dlv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_linkref__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__cube_performance__ = __webpack_require__(80);
var _dec, _trackingProvider, _class;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var RATIO_MAP = {
	'3:2': 'threeByTwo',
	'4:3': 'fourByThree',
	'16:9': 'sixteenByNine'
};

var Pending = function Pending(_ref) {
	var cardSizeStyle = _ref.cardSizeStyle;
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_4_classnames___default()(__WEBPACK_IMPORTED_MODULE_8__style___default.a.dcc, cardSizeStyle) },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__cube_blocks__["r" /* Spinner */], { 'class': __WEBPACK_IMPORTED_MODULE_8__style___default.a.spinner })
	);
};

var Rejected = function Rejected() {
	return null;
};

// Arrow renders the Previous and Next arrows
var Arrow = function Arrow(props, context) {
	var _trackProps;

	var direction = props.direction,
	    onClick = props.onClick,
	    goToOpposite = props.goToOpposite,
	    isInfinite = props.isInfinite;

	// This should be null at the beginning and end so we can use this to fake an infinite carousel

	var clickEvent = onClick || !isInfinite && goToOpposite;

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_4_classnames___default()(__WEBPACK_IMPORTED_MODULE_8__style___default.a.arrow, __WEBPACK_IMPORTED_MODULE_8__style___default.a[direction]), onClick: clickEvent },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__cube_blocks__["i" /* Icon */], _extends({
			name: direction === 'left' ? 'back-cube' : 'go-cube'
		}, Object(__WEBPACK_IMPORTED_MODULE_2__cube_track__["l" /* trackProps */])((_trackProps = {}, _trackProps[__WEBPACK_IMPORTED_MODULE_2__cube_track__["a" /* INPUT_KEYS */].priority] = 'medium', _trackProps[__WEBPACK_IMPORTED_MODULE_2__cube_track__["b" /* STANDARD_KEYS */].cubecomponent] = 'Arrow', _trackProps[__WEBPACK_IMPORTED_MODULE_2__cube_track__["b" /* STANDARD_KEYS */].eventtype] = direction === 'left' ? 'Previous' : 'Next', _trackProps), context)))
	);
};

/**
 * The Dcc component is a carousel for Card components.
 */

var Dcc = (_dec = Object(__WEBPACK_IMPORTED_MODULE_2__cube_track__["m" /* trackingProvider */])((_trackingProvider = {}, _trackingProvider[__WEBPACK_IMPORTED_MODULE_2__cube_track__["b" /* STANDARD_KEYS */].cubecomponent] = 'Dcc', _trackingProvider[__WEBPACK_IMPORTED_MODULE_2__cube_track__["b" /* STANDARD_KEYS */].contentarea] = 'dcc', _trackingProvider)), _dec(_class = function (_Component) {
	_inherits(Dcc, _Component);

	function Dcc() {
		var _temp, _this, _ret;

		_classCallCheck(this, Dcc);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.currentSlideIndex = 0, _this.firedImpressions = [], _this.getLink = Object(__WEBPACK_IMPORTED_MODULE_11__lib_collection__["b" /* getCardWidget */])('default').getLink, _this.customPaging = function (i) {
			return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'span',
				null,
				i + 1,
				' / ',
				_this.props.slides.length
			);
		}, _this.slickInit = function () {
			_this.fireImpressionTracking(0);
		}, _this.goToBeginning = function () {
			if (__WEBPACK_IMPORTED_MODULE_12_dlv___default()(_this.refs, 'slider.slickGoTo')) {
				_this.refs.slider.slickGoTo(0, false);
			}
		}, _this.goToEnd = function () {
			if (__WEBPACK_IMPORTED_MODULE_12_dlv___default()(_this.refs, 'slider.slickGoTo') && _this.props.slides.length) {
				_this.refs.slider.slickGoTo(_this.props.slides.length - 1, false);
			}
		}, _this.afterChange = function (i) {
			// Clear our rotate handler if it set as we have already moved through some mechanism other than it
			if (_this.rotateTimeoutHandle) {
				window.clearTimeout(_this.rotateTimeoutHandle);
				_this.rotateTimeoutHandle = null;
			}

			var autoRotate = __WEBPACK_IMPORTED_MODULE_12_dlv___default()(_this.props, 'carouselSettings.autoRotate', true),
			    autoRotateFrequency = __WEBPACK_IMPORTED_MODULE_12_dlv___default()(_this.props, 'carouselSettings.autoRotateFrequency');

			// Fake an infinite carousel so we don't get cloned slides
			if (i === _this.props.slides.length - 1 && autoRotate && autoRotateFrequency) {
				_this.rotateTimeoutHandle = window.setTimeout(function () {
					_this.refs.slider.slickGoTo(0, false);
					_this.rotateTimeoutHandle = null;
				}, autoRotateFrequency);
			}

			// If just changed from first slide and autoRotateFrequency is provided, then use it.
			if (i === 1 && autoRotateFrequency) {
				_this.setState({ autoplaySpeed: autoRotateFrequency });
			}

			_this.currentSlideIndex = i;
			_this.fireImpressionTracking(i);

			//update slides JSX to prepare the upcoming slides so they fetch their images
			_this.setState({});
		}, _this.fireImpressionTracking = function (i) {
			if (_this.props.slides.length >= i && _this.firedImpressions.indexOf(i) === -1) {
				var _extends2, _extends3;

				Object(__WEBPACK_IMPORTED_MODULE_2__cube_track__["k" /* trackEvent */])(_this.context, _extends((_extends2 = {}, _extends2[__WEBPACK_IMPORTED_MODULE_2__cube_track__["a" /* INPUT_KEYS */].action] = 'impression', _extends2[__WEBPACK_IMPORTED_MODULE_2__cube_track__["b" /* STANDARD_KEYS */].cubecomponent] = 'Card', _extends2), Object(__WEBPACK_IMPORTED_MODULE_2__cube_track__["i" /* getTrackingAttributesForAsset */])(_this.props.slides[i], 'medium'), (_extends3 = {}, _extends3[__WEBPACK_IMPORTED_MODULE_2__cube_track__["b" /* STANDARD_KEYS */].contentsecondaryposition] = i, _extends3)));

				_this.firedImpressions.push(i);
			}
		}, _this.onCardClick = function (_ref2) {
			var _ref2$pause = _ref2.pause,
			    pause = _ref2$pause === undefined ? false : _ref2$pause;

			if (pause) _this.refs.slider.slickPause();
		}, _this.onFirstImageLoad = function () {
			if (!_this.firstImageLoaded) {
				_this.firstImageLoaded = true;
				Object(__WEBPACK_IMPORTED_MODULE_14__cube_performance__["markPerformance"])('dcc_first_slide_image');
			}
		}, _this.onEnter = function (e) {
			if (e.keyCode === 13 && _this.currentSlideIndex) {
				var currentSlide = __WEBPACK_IMPORTED_MODULE_12_dlv___default()(_this.refs.slider, 'innerSlider.list.childNodes.0.childNodes.' + (_this.currentSlideIndex + 1));
				if (currentSlide) {
					// Get the top level element of the current slide and fire a click action on it
					currentSlide.firstElementChild.firstElementChild.click();
				}
			}
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	// customPaging displays (current / total) slides


	// mapCarouselToSlick maps our own terminology to slick specific settings
	Dcc.prototype.mapCarouselToSlick = function mapCarouselToSlick(autoplaySpeed) {
		var _this2 = this;

		var slickSettings = {};
		var carouselSettings = this.props.carouselSettings || {};
		var mapping = {
			autoRotate: 'autoplay',
			showPageCount: 'dots',
			transitionSpeed: 'speed'
		};

		Object.keys(carouselSettings).forEach(function (key, i) {
			if (mapping[key]) {
				slickSettings[mapping[key]] = carouselSettings[key];
			}
		});

		if (autoplaySpeed) {
			slickSettings.autoplaySpeed = autoplaySpeed;
		}

		slickSettings.infinite = carouselSettings.infinite || false;

		if (carouselSettings.showArrows) {
			slickSettings.nextArrow = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Arrow, { direction: 'right', goToOpposite: this.goToBeginning, isInfinite: slickSettings.infinite });
			slickSettings.prevArrow = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Arrow, { direction: 'left', goToOpposite: this.goToEnd, isInfinite: slickSettings.infinite });
		} else {
			slickSettings.arrows = false;
		}

		if (carouselSettings.showPageCount) {
			slickSettings.customPaging = this.customPaging;
		}

		slickSettings.afterChange = this.afterChange;
		slickSettings.onInit = this.slickInit;

		// Set clickable true to work around bug https://github.com/akiran/react-slick/issues/1298
		slickSettings.onSwipe = function () {
			if (__WEBPACK_IMPORTED_MODULE_12_dlv___default()(_this2, 'refs.slider.innerSlider')) {
				_this2.refs.slider.innerSlider.clickable = true;
			}
		};

		return slickSettings;
	};

	/**
  * Primarily used to send tracking information about the card that was clicked, but
  * also allows child components to pause the carousel from advancing in the case that
  * this card is playing a video.
  *
  * @param {Object} e - Event object
  * @param {Boolean} e.pause - Whether or not to stop the carousel from advancing to new slides
  */


	Dcc.prototype.getCardSizeStyle = function getCardSizeStyle(cardSize) {
		if (!cardSize) return '';

		var suffix = cardSize.indexOf('-') > 0 ? cardSize.substring(cardSize.indexOf('-') + 1) : '3:2';
		if (RATIO_MAP[suffix]) {
			return __WEBPACK_IMPORTED_MODULE_8__style___default.a[RATIO_MAP[suffix]];
		}
		return '';
	};

	Dcc.prototype.componentWillMount = function componentWillMount() {
		// On mount, use first slide speed if available.  If not then use default from config
		var carouselSettings = this.props.carouselSettings || {};
		this.setState({
			autoplaySpeed: carouselSettings.firstSlideAutoRotateFrequency ? carouselSettings.firstSlideAutoRotateFrequency : carouselSettings.autoRotateFrequency
		});
	};

	Dcc.prototype.componentDidUpdate = function componentDidUpdate() {
		var list = __WEBPACK_IMPORTED_MODULE_12_dlv___default()(this.refs, 'slider.innerSlider.list');
		if (list && list.getAttribute('tabindex') === null) {
			// This allows user to tab to the div where they can then use the arrow keys to navigate.
			list.setAttribute('tabindex', 0);

			// This sets the priority for the screen readers so it will read as each slide goes by.
			list.setAttribute('aria-live', 'polite');

			// This handles the enter key acting like a click action to follow the card.  This will only target a
			// main click action for the card and will not work for multi-content cards like the truck card.
			list.addEventListener('keypress', this.onEnter);
		}
	};

	Dcc.prototype.renderSlides = function renderSlides(_ref3) {
		var _this3 = this;

		var slides = _ref3.slides,
		    cardSize = _ref3.cardSize,
		    lazySlideWindowSize = _ref3.lazySlideWindowSize,
		    validCategories = _ref3.validCategories,
		    overlayMode = _ref3.overlayMode;

		var cardTypeCounts = {};
		return slides.map(function (slide, i) {
			var _ref4;

			var cardType = Object(__WEBPACK_IMPORTED_MODULE_11__lib_collection__["a" /* getCardType */])(slide),
			    Card = Object(__WEBPACK_IMPORTED_MODULE_11__lib_collection__["b" /* getCardWidget */])(slide).Card,
			    lazy = Math.abs(i - _this3.currentSlideIndex) > lazySlideWindowSize;

			if (cardTypeCounts[cardType]) cardTypeCounts[cardType]++;else cardTypeCounts[cardType] = 1;

			return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				__WEBPACK_IMPORTED_MODULE_2__cube_track__["c" /* TrackingProvider */],
				(_ref4 = {}, _ref4[__WEBPACK_IMPORTED_MODULE_2__cube_track__["b" /* STANDARD_KEYS */].contentsecondaryposition] = i + 1, _ref4),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Card, {
					settings: slide //<-to deprecate
					, scsData: slide,
					cardSize: cardSize,
					lazy: lazy,
					onCardClick: _this3.onCardClick,
					onImageLoad: i === 0 ? _this3.onFirstImageLoad : undefined,
					startContentServiceOrigin: _this3.props.startContentServiceOrigin,
					streamClient: _this3.props.streamClient,
					validCategories: validCategories,
					overlayMode: overlayMode,
					slideNumber: i + 1,
					cardTypeCount: cardTypeCounts[cardType]
				})
			);
		});
	};

	Dcc.prototype.render = function render(_ref5, _ref6) {
		var cardSize = _ref5.cardSize,
		    lazySlideWindowSize = _ref5.lazySlideWindowSize,
		    validCategories = _ref5.validCategories,
		    _ref5$slides = _ref5.slides,
		    slides = _ref5$slides === undefined ? [] : _ref5$slides,
		    pending = _ref5.pending,
		    rejected = _ref5.rejected,
		    overlayMode = _ref5.overlayMode;
		var autoplaySpeed = _ref6.autoplaySpeed;

		var cardSizeStyle = this.getCardSizeStyle(cardSize);

		if (pending && !slides.length) {
			return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Pending, { cardSizeStyle: cardSizeStyle });
		}

		if (rejected || !slides.length) {
			return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Rejected, null);
		}

		//TODO: the this.mapCarouselToSlick call rebuilds the UI on every render. This should only be called when needed.
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'data-tb-region': 'dcc_desktop_v2' },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				__WEBPACK_IMPORTED_MODULE_3__synacorforks_react_slick___default.a,
				_extends({
					ref: Object(__WEBPACK_IMPORTED_MODULE_13_linkref__["a" /* default */])(this, 'slider')
				}, this.mapCarouselToSlick(autoplaySpeed), {
					'class': __WEBPACK_IMPORTED_MODULE_4_classnames___default()(__WEBPACK_IMPORTED_MODULE_8__style___default.a.dcc, __WEBPACK_IMPORTED_MODULE_8__style___default.a[overlayMode], cardSizeStyle)
				}),
				this.renderSlides({ cardSize: cardSize, slides: slides, lazySlideWindowSize: lazySlideWindowSize, validCategories: validCategories, overlayMode: overlayMode })
			)
		);
	};

	return Dcc;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"])) || _class);

/**
 * This component wraps the Dcc and adds the default configuration
 * as well populates itself using a function provided
 * via context `dcc:{ fetchSlides }`.
 *
 * fetchSlides is implemented as `fetchSlides(feed, site, apiOrigin, maxSlideCount)`
 * and returns a Promise that resolves to and array of SCS card data objects.
 */
var SlideFetchingDcc = Object(__WEBPACK_IMPORTED_MODULE_5_recompose__["a" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_9__config__["a" /* configure */])({
	startContentServiceOrigin: 'startContentServiceOrigin',
	streamClient: 'streamClient',
	layout: 'dccV2Config.layout',
	carouselSettings: 'dccV2Config.carouselSettings',
	maxSlideCount: 'dccV2Config.maxSlideCount',
	lazySlideWindowSize: 'dccV2Config.lazySlideWindowSize',
	validCategories: 'dccV2Config.validCategories'
}), Object(__WEBPACK_IMPORTED_MODULE_7_wiretie__["a" /* default */])('dcc', function (_ref7) {
	var startContentServiceOrigin = _ref7.startContentServiceOrigin,
	    layout = _ref7.layout,
	    streamClient = _ref7.streamClient,
	    maxSlideCount = _ref7.maxSlideCount;
	return {
		slides: ['fetchSlides', layout, streamClient, startContentServiceOrigin, maxSlideCount]
	};
}))(Dcc);

/**
 * The Dcc component with default configuration and using the standard `fetchSlides()`
 * as implemented for the SCS.
 */
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_recompose__["a" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_6_preact_context_provider__["b" /* provide */])({ dcc: { fetchSlides: __WEBPACK_IMPORTED_MODULE_10__lib_utils__["a" /* fetchSlides */] } }))(SlideFetchingDcc));

/***/ }),

/***/ 772:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"dcc":"dcc-widget-v2_dcc_x","fourByThree":"dcc-widget-v2_dcc_fourByThree","sixteenByNine":"dcc-widget-v2_dcc_sixteenByNine","desktop":"dcc-widget-v2_dcc_desktop","arrow":"dcc-widget-v2_dcc_arrow","right":"dcc-widget-v2_dcc_right","left":"dcc-widget-v2_dcc_left","spinner":"dcc-widget-v2_dcc_spinner"};

/***/ }),

/***/ 773:
/***/ (function(module, exports) {

module.exports = {"startContentServiceOrigin":"https://scs.imds-api.com","streamClient":"glados","taboolaConfig":{"url":"https://api.taboola.com/1.2/json/","client":"synacor-synacor","endpoint":"recommendations.get","apikey":"1072f6b2b50d5e2d80cee9f2608d28b39e29bce5"},"dccV2Config":{"carouselSettings":{"autoRotate":true,"firstSlideAutoRotateFrequency":8000,"autoRotateFrequency":5000,"showArrows":true,"showPageCount":true,"transitionSpeed":200},"layout":"gen4_dcc_foryou","lazySlideWindowSize":1,"maxSlideCount":30,"validCategories":["Sports","News","Entertainment","Finance","Games"],"isTransparentIcons":false,"singleAsset":{"defaultImageSize":"small-3:2"},"promoOneImage":{"defaultImageSize":"small-3:2"}}}

/***/ }),

/***/ 774:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export canRender */
/* unused harmony export getLink */
/* unused harmony export Card */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cube_layout__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cube_intent_to_url__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dlv__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dlv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_dlv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_utils__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__cube_track__ = __webpack_require__(73);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _dec, _trackingProvider, _class;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var canRender = function canRender(slide) {
	if (slide.assets) {
		slide.assets = slide.assets.filter(function (asset) {
			return asset.images && asset.images.length > 0 && asset.title_long;
		});
		return slide.assets.length > 0;
	}

	return false;
};

var getLink = function getLink(slide) {
	return Object(__WEBPACK_IMPORTED_MODULE_3__cube_intent_to_url__["a" /* intentObjToUrl */])(__WEBPACK_IMPORTED_MODULE_5_dlv___default()(slide, 'assets.0.link'));
};

var Card = (_dec = Object(__WEBPACK_IMPORTED_MODULE_10__cube_track__["m" /* trackingProvider */])((_trackingProvider = {}, _trackingProvider[__WEBPACK_IMPORTED_MODULE_10__cube_track__["b" /* STANDARD_KEYS */].cubecomponent] = 'SingleAsset', _trackingProvider)), _dec(_class = function (_Component) {
	_inherits(Card, _Component);

	function Card() {
		var _temp, _this, _ret;

		_classCallCheck(this, Card);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onCardClick = function (e) {
			if (_this.props.onCardClick) _this.props.onCardClick({ pause: false });
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	Card.prototype.getIcon = function getIcon(settings, isTransparentIcons) {
		if (__WEBPACK_IMPORTED_MODULE_5_dlv___default()(settings, 'assets.0.icon') === 'video') {
			return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__cube_blocks__["i" /* Icon */], { 'class': __WEBPACK_IMPORTED_MODULE_4_classnames___default()(__WEBPACK_IMPORTED_MODULE_7__style___default.a.icon, __WEBPACK_IMPORTED_MODULE_7__style___default.a.video, isTransparentIcons && __WEBPACK_IMPORTED_MODULE_7__style___default.a.transparent), name: 'play-cube' });
		}
		if (__WEBPACK_IMPORTED_MODULE_5_dlv___default()(settings, 'assets.0.metadata.attribution.citation') === 'Slideshow') {
			return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__cube_blocks__["i" /* Icon */], { 'class': __WEBPACK_IMPORTED_MODULE_4_classnames___default()(__WEBPACK_IMPORTED_MODULE_7__style___default.a.icon, __WEBPACK_IMPORTED_MODULE_7__style___default.a.slideshow, isTransparentIcons && __WEBPACK_IMPORTED_MODULE_7__style___default.a.transparent), name: 'gallery-cube' });
		}

		return false;
	};

	Card.prototype.getLinkoutParams = function getLinkoutParams(settings) {
		if (__WEBPACK_IMPORTED_MODULE_5_dlv___default()(settings, 'assets.0.link.open_new_window')) {
			return {
				target: '_blank',
				rel: 'noopener noreferrer'
			};
		}
	};

	Card.prototype.render = function render(_ref) {
		var settings = _ref.settings,
		    cardSize = _ref.cardSize,
		    overlayMode = _ref.overlayMode,
		    validCategories = _ref.validCategories,
		    lazy = _ref.lazy,
		    isTransparentIcons = _ref.isTransparentIcons,
		    onImageLoad = _ref.onImageLoad,
		    props = _objectWithoutProperties(_ref, ['settings', 'cardSize', 'overlayMode', 'validCategories', 'lazy', 'isTransparentIcons', 'onImageLoad']);

		if (!cardSize) cardSize = props.defaultImageSize;

		var styleProps = {};
		var backgroundImage = Object(__WEBPACK_IMPORTED_MODULE_9__lib_utils__["b" /* getImage */])(settings, cardSize);
		if (!lazy || this.loadedBG === backgroundImage) {
			// If actually loading for first time and onImageLoad defined, fire it
			if (onImageLoad && !this.loadedBG) {
				Object(__WEBPACK_IMPORTED_MODULE_9__lib_utils__["c" /* loadBgImage */])(backgroundImage, onImageLoad);
			}

			styleProps.style = 'background-image: url(\'' + backgroundImage + '\')';
			this.loadedBG = backgroundImage;
		}
		var icon = this.getIcon(settings, isTransparentIcons);
		var cardCategory = __WEBPACK_IMPORTED_MODULE_5_dlv___default()(settings, 'metadata.category');
		var isValidCategory = validCategories ? validCategories.find(function (category) {
			return category === cardCategory;
		}) : false;

		var category = isValidCategory ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'span',
			{ 'class': __WEBPACK_IMPORTED_MODULE_7__style___default.a.category },
			cardCategory
		) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('span', { className: __WEBPACK_IMPORTED_MODULE_7__style___default.a.noCategory });

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'data-tb-region-item': true, 'class': __WEBPACK_IMPORTED_MODULE_7__style___default.a.wrapperDiv },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'a',
				_extends({
					href: getLink(settings)
				}, this.getLinkoutParams(settings), styleProps, {
					'class': __WEBPACK_IMPORTED_MODULE_4_classnames___default()(__WEBPACK_IMPORTED_MODULE_7__style___default.a.cardSingleAsset, __WEBPACK_IMPORTED_MODULE_7__style___default.a[overlayMode]),
					onClick: this.onCardClick
				}, Object(__WEBPACK_IMPORTED_MODULE_10__cube_track__["l" /* trackProps */])(Object(__WEBPACK_IMPORTED_MODULE_10__cube_track__["i" /* getTrackingAttributesForAsset */])(settings), this.context)),
				icon,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_1__cube_layout__["Row"],
					{ 'class': __WEBPACK_IMPORTED_MODULE_7__style___default.a.row },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						__WEBPACK_IMPORTED_MODULE_1__cube_layout__["Column"],
						null,
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							'div',
							{ 'class': __WEBPACK_IMPORTED_MODULE_7__style___default.a.title },
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								__WEBPACK_IMPORTED_MODULE_2__cube_blocks__["o" /* RenderOnVisible */],
								null,
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									__WEBPACK_IMPORTED_MODULE_2__cube_blocks__["v" /* Truncate */],
									{ method: 'multipleLines', lines: '2' },
									__WEBPACK_IMPORTED_MODULE_5_dlv___default()(settings, 'assets.0.title_long')
								)
							)
						)
					)
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_1__cube_layout__["Row"],
					{ 'class': __WEBPACK_IMPORTED_MODULE_7__style___default.a.row },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						__WEBPACK_IMPORTED_MODULE_1__cube_layout__["Column"],
						null,
						category,
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							'span',
							{ 'class': __WEBPACK_IMPORTED_MODULE_7__style___default.a.attribution },
							__WEBPACK_IMPORTED_MODULE_5_dlv___default()(settings, 'metadata.attribution.citation', __WEBPACK_IMPORTED_MODULE_5_dlv___default()(settings, 'assets.0.metadata.attribution.citation'))
						)
					)
				)
			)
		);
	};

	return Card;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"])) || _class);

var SingleAsset = {
	canRender: canRender,
	getLink: getLink,
	Card: Object(__WEBPACK_IMPORTED_MODULE_6_recompose__["a" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_8__config__["a" /* configure */])({
		defaultImageSize: 'dccV2Config.singleAsset.defaultImageSize',
		isTransparentIcons: 'dccV2Config.isTransparentIcons'
	})(Card))
};

/* harmony default export */ __webpack_exports__["a"] = (SingleAsset);

/***/ }),

/***/ 775:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapperDiv":"dcc-widget-v2_cards_singleAsset_wrapperDiv","cardSingleAsset":"dcc-widget-v2_cards_singleAsset_cardSingleAsset","icon":"dcc-widget-v2_cards_singleAsset_icon","row":"dcc-widget-v2_cards_singleAsset_row","title":"dcc-widget-v2_cards_singleAsset_title","category":"dcc-widget-v2_cards_singleAsset_category","noCategory":"dcc-widget-v2_cards_singleAsset_noCategory","attribution":"dcc-widget-v2_cards_singleAsset_attribution","slideshow":"dcc-widget-v2_cards_singleAsset_slideshow","video":"dcc-widget-v2_cards_singleAsset_video","transparent":"dcc-widget-v2_cards_singleAsset_transparent","desktop":"dcc-widget-v2_cards_singleAsset_desktop"};

/***/ }),

/***/ 776:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export canRender */
/* unused harmony export getLink */
/* unused harmony export Card */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cube_layout__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cube_blocks__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dlv__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dlv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_dlv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_utils__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__cube_track__ = __webpack_require__(73);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _dec, _trackingProvider, _class;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












// Must have asset with an image and a link
var canRender = function canRender(slide) {
	return __WEBPACK_IMPORTED_MODULE_4_dlv___default()(slide, 'assets.0.images', []).length > 0 && __WEBPACK_IMPORTED_MODULE_4_dlv___default()(slide, 'assets.0.link.href', '') !== '';
};

var getLink = function getLink(slide) {
	return __WEBPACK_IMPORTED_MODULE_4_dlv___default()(slide, 'assets.0.link.href');
};

var Card = (_dec = Object(__WEBPACK_IMPORTED_MODULE_9__cube_track__["m" /* trackingProvider */])((_trackingProvider = {}, _trackingProvider[__WEBPACK_IMPORTED_MODULE_9__cube_track__["b" /* STANDARD_KEYS */].cubecomponent] = 'PromoOneImage', _trackingProvider)), _dec(_class = function (_Component) {
	_inherits(Card, _Component);

	function Card() {
		var _temp, _this, _ret;

		_classCallCheck(this, Card);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onCardClick = function (e) {
			if (_this.props.onCardClick) _this.props.onCardClick({ pause: false });
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	Card.prototype.getLinkoutParams = function getLinkoutParams(settings) {
		if (__WEBPACK_IMPORTED_MODULE_4_dlv___default()(settings, 'assets.0.link.open_new_window')) {
			return {
				target: '_blank',
				rel: 'noopener noreferrer'
			};
		}
	};

	Card.prototype.render = function render(_ref) {
		var settings = _ref.settings,
		    cardSize = _ref.cardSize,
		    overlayMode = _ref.overlayMode,
		    lazy = _ref.lazy,
		    onImageLoad = _ref.onImageLoad,
		    props = _objectWithoutProperties(_ref, ['settings', 'cardSize', 'overlayMode', 'lazy', 'onImageLoad']);

		if (!cardSize) cardSize = props.defaultImageSize;

		var styleProps = {};
		var backgroundImage = Object(__WEBPACK_IMPORTED_MODULE_8__lib_utils__["b" /* getImage */])(settings, cardSize);
		if (!lazy || this.loadedBG === backgroundImage) {
			// If actually loading for first time and onImageLoad defined, fire it
			if (onImageLoad && !this.loadedBG) {
				Object(__WEBPACK_IMPORTED_MODULE_8__lib_utils__["c" /* loadBgImage */])(backgroundImage, onImageLoad);
			}

			styleProps.style = 'background-image: url(\'' + backgroundImage + '\')';
			this.loadedBG = backgroundImage;
		}

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'data-tb-region-item': true, 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.wrapperDiv },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'a',
				_extends({
					href: getLink(settings)
				}, this.getLinkoutParams(settings), styleProps, {
					'class': __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_6__style___default.a.cardPromoOneImage, __WEBPACK_IMPORTED_MODULE_6__style___default.a[overlayMode]),
					onClick: this.onCardClick
				}, Object(__WEBPACK_IMPORTED_MODULE_9__cube_track__["l" /* trackProps */])(Object(__WEBPACK_IMPORTED_MODULE_9__cube_track__["i" /* getTrackingAttributesForAsset */])(settings), this.context)),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_1__cube_layout__["Row"],
					{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.row },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						__WEBPACK_IMPORTED_MODULE_1__cube_layout__["Column"],
						null,
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							'div',
							{ 'class': __WEBPACK_IMPORTED_MODULE_6__style___default.a.title },
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								__WEBPACK_IMPORTED_MODULE_2__cube_blocks__["o" /* RenderOnVisible */],
								null,
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									__WEBPACK_IMPORTED_MODULE_2__cube_blocks__["v" /* Truncate */],
									{ method: 'multipleLines', lines: '2' },
									__WEBPACK_IMPORTED_MODULE_4_dlv___default()(settings, 'assets.0.title_long')
								)
							)
						)
					)
				)
			)
		);
	};

	return Card;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"])) || _class);

var PromoOneImage = {
	canRender: canRender,
	getLink: getLink,
	Card: Object(__WEBPACK_IMPORTED_MODULE_5_recompose__["a" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* configure */])({
		defaultImageSize: 'dccV2Config.promoOneImage.defaultImageSize'
	})(Card))
};

/* harmony default export */ __webpack_exports__["a"] = (PromoOneImage);

/***/ }),

/***/ 777:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapperDiv":"dcc-widget-v2_cards_promoOneImage_wrapperDiv","cardPromoOneImage":"dcc-widget-v2_cards_promoOneImage_cardPromoOneImage","row":"dcc-widget-v2_cards_promoOneImage_row","title":"dcc-widget-v2_cards_promoOneImage_title","noCategory":"dcc-widget-v2_cards_promoOneImage_noCategory","desktop":"dcc-widget-v2_cards_promoOneImage_desktop"};

/***/ }),

/***/ 778:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export canRender */
/* unused harmony export getLink */
/* unused harmony export Card */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cube_track__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__taboola_js__ = __webpack_require__(651);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _dec, _trackingProvider, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var canRender = function canRender() {
	return true;
};
var getLink = function getLink(_ref) {
	var uri = _ref.uri;
	return uri;
};

var Card = (_dec = Object(__WEBPACK_IMPORTED_MODULE_1__cube_track__["m" /* trackingProvider */])((_trackingProvider = {}, _trackingProvider[__WEBPACK_IMPORTED_MODULE_1__cube_track__["b" /* STANDARD_KEYS */].cubecomponent] = 'TaboolaJs.Organic', _trackingProvider)), _dec(_class = function (_Component) {
	_inherits(Card, _Component);

	function Card() {
		_classCallCheck(this, Card);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Card.prototype.render = function render(_ref2) {
		var slideNumber = _ref2.slideNumber;

		var id = 'taboola-dcc-' + slideNumber;
		var config = {
			taboolaJsParams: {
				mode: 'organic-thumbnails-r',
				container: id,
				placement: 'dcc-slide' + slideNumber + '-js-v2-organic',
				target_type: 'mix'
			},
			id: id
		};
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__taboola_js__["a" /* TaboolaJs */], _extends({}, config, { qeId: 'dcc-taboola-card', 'data-tb-region-item': true }));
	};

	return Card;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"])) || _class);

var Taboola = {
	canRender: canRender,
	getLink: getLink,
	Card: Card
};
/* harmony default export */ __webpack_exports__["a"] = (Taboola);

/***/ }),

/***/ 779:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export canRender */
/* unused harmony export getLink */
/* unused harmony export Card */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cube_track__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__taboola_js__ = __webpack_require__(651);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _dec, _trackingProvider, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var canRender = function canRender() {
	return true;
};
var getLink = function getLink(_ref) {
	var uri = _ref.uri;
	return uri;
};

var Card = (_dec = Object(__WEBPACK_IMPORTED_MODULE_1__cube_track__["m" /* trackingProvider */])((_trackingProvider = {}, _trackingProvider[__WEBPACK_IMPORTED_MODULE_1__cube_track__["b" /* STANDARD_KEYS */].cubecomponent] = 'TaboolaJs.Sponsored', _trackingProvider)), _dec(_class = function (_Component) {
	_inherits(Card, _Component);

	function Card() {
		_classCallCheck(this, Card);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Card.prototype.render = function render(_ref2) {
		var slideNumber = _ref2.slideNumber;

		var id = 'taboola-dcc-' + slideNumber;
		var config = {
			taboolaJsParams: {
				mode: 'thumbnails-r',
				container: id,
				placement: 'dcc-slide' + slideNumber + '-js-v2',
				target_type: 'mix'
			},
			id: id
		};
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__taboola_js__["a" /* TaboolaJs */], _extends({}, config, { qeId: 'dcc-taboola-card', 'data-tb-region-item': true }));
	};

	return Card;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"])) || _class);

var Taboola = {
	canRender: canRender,
	getLink: getLink,
	Card: Card
};
/* harmony default export */ __webpack_exports__["a"] = (Taboola);

/***/ }),

/***/ 780:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export canRender */
/* unused harmony export getLink */
/* unused harmony export Card */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cube_track__ = __webpack_require__(73);
var _dec, _trackingProvider, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var canRender = function canRender() {
	return true;
};
var getLink = function getLink(_ref) {
	var uri = _ref.uri;
	return uri;
};

var Card = (_dec = Object(__WEBPACK_IMPORTED_MODULE_2__cube_track__["m" /* trackingProvider */])((_trackingProvider = {}, _trackingProvider[__WEBPACK_IMPORTED_MODULE_2__cube_track__["b" /* STANDARD_KEYS */].cubecomponent] = 'Ad', _trackingProvider)), _dec(_class = function (_Component) {
	_inherits(Card, _Component);

	function Card() {
		_classCallCheck(this, Card);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Card.prototype.render = function render(_ref2) {
		var cardTypeCount = _ref2.cardTypeCount;

		var id = 'dcc_slide_ad_' + cardTypeCount;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.ad, id: id });
	};

	return Card;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"])) || _class);

var Ad = {
	canRender: canRender,
	getLink: getLink,
	Card: Card
};
/* harmony default export */ __webpack_exports__["a"] = (Ad);

/***/ }),

/***/ 781:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ad":"dcc-widget-v2_cards_ad_x"};

/***/ }),

/***/ 782:
/***/ (function(module, exports) {

module.exports = {"dccv2":{}}

/***/ })

});


// WEBPACK FOOTER //
// widgets/dcc2.ea01993d.chunk.js